<template>

  <div class="hello ebio-chart-container" style="margin-left: 10px; margin-right: 10px;">
    <el-row>
      <!-- width <= 960px 时仅显示主视图，占满整行 -->
      <el-col :span="windowWidth <= 960 ? 24 : 13">
        <div style="position: relative; height: 95vh;">
          <div id="mainview" v-show="!show3DView" style="height: 95vh;border: 1px #e4e7ed solid;"></div>
          <div id="mainview3d" v-show="show3DView" style="height: 95vh;border: 1px #e4e7ed solid; position: relative;"></div>
              <!-- 3D图图例 - 模拟ECharts图例样式 -->
          <div v-if="show3DView && legendWithStyles.length > 0" class="legend-3d-container">
            <div class="legend-3d-item" v-for="(item, index) in legendWithStyles" :key="index">
              <span
                class="legend-3d-icon"
                :class="'legend-icon-' + item.icon"
                :style="item.iconStyle">
              </span>
              <span class="legend-3d-text">{{ item.name }}</span>
            </div>
          </div>
          <!-- 右侧边界线 -->
          <div v-show="show3DView" class="right-border-3d"></div>
          <el-button
            v-show="windowWidth > 960"
            type="primary"
            @click="toggleFullscreen"
            :style="{
              position: 'absolute',
              top: fullscreenButtonTop + 'px',
              right: fullscreenButtonRight + 'px',
              zIndex: 1000
            }"
            size="small">
            {{ isFullscreen ? 'Exit Fullscreen' : 'Fullscreen' }}
          </el-button>
          <el-button
            type="primary"
            @click="toggle3DView"
            style="position: absolute; top: 10px; right: 10px; z-index: 1000;"
            size="small">
            {{ show3DView ? 'Switch to 2D Visualization' : 'Switch to 3D Visualization' }}
          </el-button>
        </div>
      </el-col>
      <el-col :span="1" v-show="windowWidth > 960"></el-col>
      <el-col :span="10" v-show="windowWidth > 960" class="layout-panel-right">
        <el-row class="layout-panel-tabs-row">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-tabs v-model="activeTabsName_1" class="demo-tabs" style="height: 43vh">
              <div style="margin-bottom: 1vh;">
                <el-input
                    v-model="searchQuery"
                    placeholder="Enter Key Words"
                    clearable
                    size="small"
                    style="width: 300px;"
                />
              </div>
              <el-tab-pane label="Node" name="node" style="font-size: 1.2em;">
                <el-table v-fit-columns border ref="singleTable1" :data="filteredNodeData" highlight-current-row style="height: 35vh;" @current-change="handleNodeChange"
                          @selection-change="handleNodeSelectionChange" v-if="nodetableData.length > 0">
                  <el-table-column type="selection" header-align="center" align="center"></el-table-column>
                  <el-table-column type="index" label="Index" header-align="center" align="left" sortable width="100">
                    <template #header>
                      <div class="th-head"> &ensp; Index &ensp;</div>
                    </template>
                  </el-table-column>

                  <el-table-column property="name" label="节点名称" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">EXID</div>
                      <el-input v-model="query.name" placeholder="EXID" class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="name" header-align="center" align="left" sortable>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column property="category" label="节点类别" header-align="center" align="left"
                  >
                    <template #header>
                      <div class="th-head">Group name</div>
                      <el-input v-model="query.category" placeholder="Group name"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="category" header-align="center" align="left" sortable>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column property="Degree" label="Degree" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Degree</div>
                      <el-input v-model="query.degree" placeholder="Degree"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="Degree" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>


                  <el-table-column property="label" label="节点标签" header-align="center" align="left"
                  >
                    <template #header>
                      <div class="th-head">Preferred name</div>
                      <el-input v-model="query.label"
                                placeholder="Preferred name" class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="label" header-align="center" align="left" sortable>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="Edge" name="edge" style="font-size: 1.2em;">
                <el-table v-fit-columns border ref="singleTable2" :data="filteredEdgeData"
                          highlight-current-row style="height: 35vh;" @current-change="handleEdgeChange"
                          @selection-change="handleEdgeSelectionChange" v-if="edgetableData.length > 0">

                  <el-table-column type="selection" header-align="center" align="center"></el-table-column>
                  <el-table-column type="index" label="Index" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Index</div>
                    </template>
                  </el-table-column>
                  <el-table-column property="source" label="源节点" header-align="center" align="left"
                  >
                    <template #header>
                      <div class="th-head">Source</div>
                      <el-input v-model="query.source" placeholder="source"></el-input>
                    </template>
                    <el-table-column property="source" header-align="center" align="left" sortable>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column property="target" label="目标节点" header-align="center" align="left"
                  >
                    <template #header>
                      <div class="th-head">Target</div>
                      <el-input v-model="query.target" placeholder="target"></el-input>
                    </template>
                    <el-table-column property="target" header-align="center" align="left" sortable>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
        </el-row>
        <el-row class="layout-panel-divider-row">
          <el-divider content-position="left"><span class="divider-text" style="font-size: 1.2em">Layout Settings</span>
          </el-divider>
        </el-row>
        <div class="layout-settings-scroll-outer">
          <div class="layout-settings-scroll-inner">
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 2px; float: left">Label type</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">

              <el-radio-group 
                :model-value="show3DView ? nodeType3D : nodeType" 
                class="radio-row" 
                @change="changeNodeType($event)">
                <el-row class="radio-options-wrap">
                  <el-radio value="1" size="small" class="radio-first-option">Keep node size same</el-radio>
                  <el-radio value="2" size="small">Set node size proportional to edge numbers</el-radio>
                </el-row>
              </el-radio-group>
            </el-col>
            <el-col :span="1"></el-col>
          </el-row>

          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 2px; float: left">Node name</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-radio-group 
                :model-value="show3DView ? nodeNameType3D : nodeNameType" 
                class="radio-row" 
                @change="changeNodeNameType($event)">
                <el-row class="radio-options-wrap">
                  <el-radio value="1" size="small" class="radio-first-option">EXID</el-radio>
                  <el-radio value="2" size="small">Preferred name</el-radio>
                </el-row>
              </el-radio-group>
            </el-col>
            <el-col :span="1"></el-col>

          </el-row>
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <span style="margin-top: 2px; float: left" class="nowrap-text">Node size</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-row>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: left;">Min</p>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="14">
                  <el-slider 
                    v-model="currentNodeSize" 
                    :max="20" 
                    @change="changeSlider($event)"/>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: right;">Max</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1"></el-col>

          </el-row>
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <el-tooltip content="Line width" effect="dark" placement="top">
                <span style="margin-top: 2px; float: left" class="nowrap-text">Line width</span>
              </el-tooltip>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-row>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: left;">Min</p>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="14">
                  <el-slider 
                    v-model="currentEdgeSize" 
                    :max="20" 
                    @change="changeEdgeSlider($event)"/>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: right;">Max</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1"></el-col>
          </el-row>
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <span style="margin-top: 2px; float: left" class="nowrap-text">Label size</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-row>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: left;">Min</p>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="14">
                  <el-slider 
                    v-model="currentLabelSize" 
                    :max="labelSizeMax"
                    @change="changeLabelSlider($event)"/>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: right;">Max</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1"></el-col>
          </el-row>
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <span style="margin-top: 2px; float: left" class="nowrap-text">Node transparency</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-row>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: left;">Min</p>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="14">
                  <el-slider 
                    v-model="currentNodeTransparency" 
                    @change="changeNodeTransparency($event)" 
                    :max="nodeTransparencyMax" 
                    :step="1"/>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: right;">Max</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1"></el-col>

          </el-row>
          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>

            <el-col :span="3">
              <span style="margin-top: 2px; float: left" class="nowrap-text">Line transparency</span>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="16">
              <el-row>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: left;">Min</p>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="14">
                  <el-slider 
                    v-model="currentLineTransparency" 
                    @change="changeLineTransparency($event)" 
                    :max="100" 
                    :step="1"/>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="3">
                  <p style="margin-top: 2px; float: right;">Max</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1"></el-col>
          </el-row>

          <el-row style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 2px; float: left;">Line color</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="18">
              <el-row>
                <el-col :span="5">
                  <div class="demo-color-block">
                    <el-color-picker 
                      :model-value="show3DView ? linecolor3D : linecolor"
                      @change="lineColorChange($event)"/>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- Label color (only for 3D view)，放在 Line color 下面 -->
          <el-row v-if="show3DView" style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 2px; float: left;">Label color</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="18">
              <div class="demo-color-block">
                <el-color-picker 
                  v-model="labelColor3D"
                  @change="changeLabelColor3D($event)"/>
              </div>
            </el-col>
          </el-row>
          <!-- Background color (only for 3D view)，放在 Line color 下面 -->
          <el-row v-if="show3DView" style="font-size: 0.9em; min-height: 3.5vh;">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 2px; float: left; white-space: nowrap;">Background color</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="18">
              <div class="demo-color-block">
                <el-color-picker 
                  v-model="backgroundColor3D"
                  @change="changeBackgroundColor3D($event)"/>
              </div>
            </el-col>
          </el-row>
          <el-row :style="`font-size: 0.9em; min-height: ${Math.floor(colorList.length/3)*3.5}vh;`">
            <el-col :span="1"></el-col>
            <el-col :span="3">
              <p style="margin-top: 5px; float: left;">Node color</p>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="18" v-if="nodeLoad">
              <el-row>
                <el-col :span="6" v-for="(color, index) in colorList" v-bind:key="index">
                  <el-row>
                    <el-col :span="8" style="text-align: left;">
                      <div class="demo-color-block">
                        <el-color-picker 
                          :model-value="show3DView ? colorList3D[index] : colorList[index]"
                          @change="changeNodeColorList($event, index)"></el-color-picker>
                      </div>
                    </el-col>
                    <el-col :span="16">
                      <p style="margin-top: 5px;float: left;">{{ categories[index]['name'] }}</p>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="19">
        <el-button class="metaboBtn" style="min-width: 80px; height: 20px; padding: 6px 12px; font-size: 12px; background-color: #409EFF; color: white; border-color: #409EFF;" @click="saveViewSvg">SaveSvg</el-button>
        <el-button class="metaboBtn" style="min-width: 80px; height: 20px; padding: 6px 12px; font-size: 12px; background-color: #409EFF; color: white; border-color: #409EFF;" @click="saveView">SavePng</el-button>
        <el-button class="metaboBtn" style="min-width: 80px; height: 20px; padding: 6px 12px; font-size: 12px; background-color: #409EFF; color: white; border-color: #409EFF;" @click="restoreView">Restore</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-divider content-position="left"><span class="divider-text" style="font-size: 1.2em;">Full Data</span>
        </el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="border: 1px #e4e7ed solid;" class="full-data-section">
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-tabs v-model="activeTabsName_2" class="demo-tabs full-data-tabs">
              <el-tab-pane label="Node" name="node" style="font-size: 0.9em;">
                <el-table border ref="singleTable3" :data="filterNodeQueryAll" highlight-current-row
                          style="height: 700px;" class="full-data-table">
                  <el-table-column type="index" label="Index" header-align="center" align="left"
                                   width="65">
                  </el-table-column>
                  <el-table-column property="EXID" label="节点名称" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">EXID</div>
                      <el-input v-model="queryAll.EXID" placeholder="EXID" class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="EXID" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>
                  <el-table-column property="Preferred name" label="节点类别" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Preferred name</div>
                      <el-input v-model="queryAll.PreferredName" placeholder="Preferred name"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="Preferred name" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>
                  <el-table-column property="Group name" label="节点标签" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Group name</div>
                      <el-input v-model="queryAll.GroupName" placeholder="Group name"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="Group name" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>

                  <el-table-column property="Degree" label="Degree" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Degree</div>
                      <el-input v-model="queryAll.Degree" placeholder="Degree"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="Degree" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>

                  <el-table-column v-if="showNodeIdColumn" property="ID" label="ID" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">ID</div>
                      <el-input v-model="queryAll.ID" placeholder="ID" class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="ID" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>

                  <el-table-column v-if="showNodeSynonymsColumn" property="Synonyms" label="Synonyms" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Synonyms</div>
                      <el-input v-model="queryAll.Synonyms" placeholder="Synonyms"
                                class="centered-placeholder"></el-input>
                    </template>
                    <el-table-column property="Synonyms" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>

                </el-table>
              </el-tab-pane>
              <el-tab-pane label="Edge" name="edge" style="font-size: 0.9em;">
                <el-table border ref="singleTable4" :data="filterEdgeQueryAll"
                          highlight-current-row style="height: 700px;" class="full-data-table">
                  <el-table-column type="index" label="Index" header-align="center" align="center"
                                   width="65"></el-table-column>

                  <el-table-column property="Source" label="Source" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Source</div>
                      <el-input v-model="queryAll.Source" placeholder="Source"></el-input>
                    </template>
                    <el-table-column property="Source" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>
                  <el-table-column property="Target" label="Target" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Target</div>
                      <el-input v-model="queryAll.Target" placeholder="Target"></el-input>
                    </template>
                    <el-table-column property="Target" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>

                  <el-table-column property="Source preferred name" label="Source preferred name" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Source preferred name</div>
                      <el-input v-model="queryAll.SourcePreferredName" placeholder="Source preferred name"></el-input>
                    </template>
                    <el-table-column property="Source preferred name" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>

                  <el-table-column property="Target preferred name" label="Target preferred name" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Target preferred name</div>
                      <el-input v-model="queryAll.TargetPreferredName" placeholder="Target preferred name"></el-input>
                    </template>
                    <el-table-column property="Target preferred name" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>

                  <el-table-column v-if="showEdgeInteractionColumn" property="Interaction" label="Interaction" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Interaction</div>
                      <el-input v-model="queryAll.Interaction" placeholder="Interaction"></el-input>
                    </template>
                    <el-table-column property="Interaction" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>
                  <el-table-column property="Source group" label="Source group" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Source group</div>
                      <el-input v-model="queryAll.SourceGroup" placeholder="Source group"></el-input>
                    </template>
                    <el-table-column property="Source group" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>
                  <el-table-column property="Target group" label="Target group" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Target group</div>
                      <el-input v-model="queryAll.TargetGroup" placeholder="Target group"></el-input>
                    </template>
                    <el-table-column property="Target group" header-align="center" align="left"
                                     sortable></el-table-column>
                  </el-table-column>
                  <el-table-column v-if="showEdgeDatabaseColumn" property="Database" label="Database" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Database</div>
                      <el-input v-model="queryAll.Database" placeholder="Database"></el-input>
                    </template>
                    <el-table-column property="Database" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>
                  <el-table-column v-if="showEdgeTypeColumn" property="Edge type" label="Edge type" header-align="center" align="left">
                    <template #header>
                      <div class="th-head">Edge type</div>
                      <el-input v-model="queryAll.EdgeType" placeholder="Edge type"></el-input>
                    </template>
                    <el-table-column property="Edge type" header-align="center" align="left" sortable></el-table-column>
                  </el-table-column>

                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  ElMessage
} from 'element-plus';
import chroma from 'chroma-js';
import axios from "axios";
import Papa from "papaparse";
import { mapGetters, mapActions } from 'vuex';
import ForceGraph3D from '3d-force-graph';
import SpriteText from 'three-spritetext';

/** Label size 进度条最大值：2D = 20，3D = 10 */
const LABEL_SIZE_MAX_2D = 20;
const LABEL_SIZE_MAX_3D = 10;

/** Node transparency 进度条最大值：2D = 100，3D = 50 */
const NODE_TRANSPARENCY_MAX_2D = 100;
const NODE_TRANSPARENCY_MAX_3D = 50;

export default {
  name: 'HelloWorld',
  props: {
    localNodeCsv: {
      type: String,
      default: ''
    },
    localEdgeCsv: {
      type: String,
      default: ''
    },
    chartTitle: {
      type: String,
      default: ''
    },
    skipUserStatus: {
      type: Boolean,
      default: false
    },
    categoryColorOverrides: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: null,
      modelName: null,
      nodevSize: 10,
      nodevSize3D: 10, // 3D视图独立的节点大小，初始值与2D一致
      edgeSize: 10,
      edgeSize3D: 10, // 3D视图独立的边粗细，初始值与2D一致
      labelSize: 10,
      frontSize: 10,
      frontSize3D: 5, // 3D视图独立的标签大小
      nodeTransparency: 50,
      nodeTransparency3D: 25, // 3D视图独立的节点透明度
      lineTransparency: 50,
      lineTransparency3D: 50, // 3D视图独立的边透明度，初始值与2D一致
      nodetableData: [],
      edgetableData: [],
      currentRow: null,
      multipleNodeSelection: [],
      multipleEdgeSelection: [],
      nodeSource: [],
      edgeSource: [],
      nodes: [],
      edges: [],
      option: {},
      nodesearch: '',
      edgesearch: '',
      nodeSourceSearch: '',
      edgeSourceSearch: '',
      searchQuery: '',
      activeTabsName_1: "node",
      activeTabsName_2: "node",
      linecolor: "#515F6E",
      linecolor3D: "#ffffff", // 3D视图独立的边颜色，默认白色
      backgroundColor3D: "#000000", // 3D视图的背景颜色
      labelColor3D: "#ffffff", // 3D视图的标签颜色，默认白色
      categories: [],
      legend: [],
      nodeScaleFactor: 1,
      colorList: ['#5470c6', '#fac858', '#fac858', '#fac858', '#fac858', '#fac858', '#3ba272'],
      colorList3D: ['#5470c6', '#fac858', '#fac858', '#fac858', '#fac858', '#fac858', '#3ba272'], // 3D视图独立的颜色列表
      colorList3DBase: ['#5470c6', '#fac858', '#fac858', '#fac858', '#fac858', '#fac858', '#3ba272'], // 3D视图原始颜色列表（不带透明度），用于透明度计算
      proteinColorList: {
        "protein": "#e3dd4b",
        "protein_1": "#fac858",
        "protein_2": "#276820",
        "protein_3": "#e46a07",
        "protein_4": "#7331d6"
      },
      images: [],
      highlightNode: [],
      redirectSession: null,
      netDataType: null,
      netNodes: null,
      netEdges: null,
      nodeLoad: false,
      edgeLoad: false,
      dataLoading: true, // 总的数据加载状态
      title: "ExposomeX",
      query: {
        index: "",
        name: "",
        label: "",
        category: "",
        target: "",
        source: "",
        degree:"",
      },
      legends_set: {
        'Exposure': 'circle',
        'Disease': 'circle',
        'Protein_1': 'circle',
        'Protein_1 (prot)': 'triangle',
        'Protein_1 (met)': 'diamond',
        'Protein_2': 'circle',
        'Protein_2 (prot)': 'triangle',
        'Protein_2 (met)': 'diamond',
      },

      queryAll: {
        Degree: "",
        EXID: "",
        PreferredName: "",
        GroupName: "",
        ID: "",
        Synonyms: "",
        Source: "",
        Target: "",
        SourcePreferredName: "",
        TargetPreferredName: "",
        Interaction: "",
        SourceGroup: "",
        TargetGroup: "",
        Database: "",
        EdgeType: "",
      },
      nodeType: "2",
      nodeType3D: "2", // 3D视图独立的节点类型，初始值与2D一致
      nodeNameType: "2",
      nodeNameType3D: "2", // 3D视图独立的节点名称类型，初始值与2D一致
      nodeScaleFactor3D: 1, // 3D视图独立的节点缩放因子，用于nodeType3D == "2"时
      nowCenter: [],
      show3DView: true, // 控制显示2D还是3D视图，默认显示3D
      graph3D: null, // 3d-force-graph 实例
      highlightNodes: new Set(), // 选中的节点集合
      hoverNode: null, // 鼠标悬停的节点
      isFullscreen: false, // 控制是否全屏显示
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1920, // 窗口宽度，用于响应式设计
      colorsInitialized: false,
    }
  },
  created() {
    console.log('🎬 [created] Vue组件创建完成，开始初始化...');
    console.log('🌐 [created] 当前页面URL:', window.location.href);
    
    if (!this.skipUserStatus) {
      this.fetchUserStatus();
    }

    if (this.hasInjectedCsvData) {
      this.initializeInjectedData();
    } else {
      this.getAllData();
    }
  },
  

  mounted() {
    console.log('🏗️ [mounted] Vue组件挂载完成');
    console.log('📐 [mounted] DOM元素状态:', {
      mainviewExists: !!document.getElementById('mainview'),
      mainview3dExists: !!document.getElementById('mainview3d'),
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    });
    
    // 初始化窗口宽度
    this.windowWidth = window.innerWidth;
    
    // 只有在显示2D视图时才初始化2D视图
    if (!this.show3DView) {
      this.showFigure();
    }
    
    window.addEventListener('resize', this.handleResize);
    console.log('✅ [mounted] 事件监听器已添加');
  },
  beforeUnmount() {
    // 在组件卸载之前移除事件监听器
    window.removeEventListener('resize', this.handleResize);
    // 移除全屏监听器
    this.removeFullscreenListeners();
    // 如果还在全屏状态，退出全屏
    if (this.isFullscreen) {
      this.exitFullscreen();
    }
    // 清理防抖定时器
    if (this._updateHighlightTimer) {
      clearTimeout(this._updateHighlightTimer);
      this._updateHighlightTimer = null;
    }
    // 清理resize防抖定时器
    if (this._resizeTimer) {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = null;
    }
    // 重置渲染标志位
    this._isRendering3D = false;
    
    // 清理数据转换缓存
    this._cachedGDataBase = null;
    this._cachedNodesLength = null;
    this._cachedEdgesLength = null;
    this._cachedFirstNodeId = null;
    this._cachedLastNodeId = null;
    this._cachedFirstEdgeSource = null;
    
    // 清理 3D 图形资源
    if (this.graph3D) {
      try {
        // 清理 WebGL 上下文
        if (this.graph3D.renderer && this.graph3D.renderer.getContext) {
          const gl = this.graph3D.renderer.getContext();
          if (gl) {
            const loseContext = gl.getExtension('WEBGL_lose_context');
            if (loseContext) {
              loseContext.loseContext();
            }
          }
        }
        this.graph3D._destructor();
      } catch (error) {
        console.warn('⚠️ [beforeUnmount] 清理 3D 图形时出错:', error);
      }
      this.graph3D = null;
    }
  },
  computed: {
    hasInjectedCsvData() {
      return Boolean(this.localNodeCsv && this.localEdgeCsv);
    },
    showNodeIdColumn() {
      return this.hasColumnData(this.nodeSource, ['ID']);
    },
    showNodeSynonymsColumn() {
      return this.hasColumnData(this.nodeSource, ['Synonyms']);
    },
    showEdgeInteractionColumn() {
      return this.hasColumnData(this.edgeSource, ['Interaction', 'interaction']);
    },
    showEdgeDatabaseColumn() {
      return this.hasColumnData(this.edgeSource, ['Database', 'database']);
    },
    showEdgeTypeColumn() {
      return this.hasColumnData(this.edgeSource, ['Edge type', 'edge_type']);
    },
    /** Label size 进度条最大值：2D 为 20，3D 为 10 */
    labelSizeMax() {
      return this.show3DView ? LABEL_SIZE_MAX_3D : LABEL_SIZE_MAX_2D;
    },
    /** Node transparency 进度条最大值：2D 为 100，3D 为 50 */
    nodeTransparencyMax() {
      return this.show3DView ? NODE_TRANSPARENCY_MAX_3D : NODE_TRANSPARENCY_MAX_2D;
    },
    filterNodeQueryAll() {
      // 检查数据是否已加载
      if (this.dataLoading || !this.nodeSource || this.nodeSource.length === 0) {
        console.log('🔄 [filterNodeQueryAll] 数据尚未加载，返回空数组');
        return [];
      }

      if (this.queryAll.EXID == "" && this.queryAll.PreferredName == "" && this.queryAll.GroupName == "" &&
          this.queryAll.ID == "" && this.queryAll.Synonyms == "" &&  this.queryAll.Degree == "") {

        return (this.nodeSource || []).filter(data => {
          // 添加数据有效性检查
          if (!data || typeof data !== 'object') {
            console.warn('⚠️ [filterNodeQueryAll] 发现无效数据项:', data);
            return false;
          }
          
          // 检查query过滤条件
          const queryMatch = !this.query || (
            (data.EXID || '').toLowerCase().includes((this.query.name || '').toLowerCase()) &&
            (data.EXID || '').toLowerCase().includes((this.query.category || '').toLowerCase()) &&
            (data.EXID || '').toLowerCase().includes((this.query.label || '').toLowerCase())
          );
          
          // 检查searchQuery过滤条件
          const searchMatch = !this.searchQuery || (
            (data.EXID || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
            (data.EXID || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
            (data.EXID || '').toLowerCase().includes(this.searchQuery.toLowerCase())
          );
          
          return queryMatch && searchMatch;
        });
      }
      
      //EXID,Preferred name,Group name,ID,Synonyms
      return (this.nodeSource || []).filter(data => {
        // 添加数据有效性检查
        if (!data || typeof data !== 'object') {
          console.warn('⚠️ [filterNodeQueryAll] 发现无效数据项:', data);
          return false;
        }
        
        // 检查queryAll过滤条件
        const queryAllMatch = !this.queryAll || (
          (data.EXID || '').toLowerCase().includes((this.queryAll.EXID || '').toLowerCase()) &&
          (data["Preferred name"] || '').toLowerCase().includes((this.queryAll.PreferredName || '').toLowerCase()) &&
          (data["Group name"] || '').toLowerCase().includes((this.queryAll.GroupName || '').toLowerCase()) &&
          (data["ID"] || '').toLowerCase().includes((this.queryAll.ID || '').toLowerCase()) &&
          (data["Synonyms"] || '').toLowerCase().includes((this.queryAll.Synonyms || '').toLowerCase()) &&
          (data["Degree"] || '').toString().toLowerCase().includes((this.queryAll.Degree || '').toLowerCase())
        );
        
        return queryAllMatch;
      });
    },
    filteredNodeData() {
      // 检查数据是否已加载
      if (this.dataLoading || !this.nodetableData || this.nodetableData.length === 0) {
        console.log('🔄 [filteredNodeData] 数据尚未加载，返回空数组');
        return [];
      }
      
      return (this.nodetableData || []).filter(data => {
        // 添加数据有效性检查
        if (!data || typeof data !== 'object') {
          console.warn('⚠️ [filteredNodeData] 发现无效数据项:', data);
          return false;
        }
        
        // 检查query过滤条件
        const queryMatch = !this.query || (
          (data.name || '').toLowerCase().includes((this.query.name || '').toLowerCase()) &&   
          (data.category || '').toLowerCase().includes((this.query.category || '').toLowerCase()) &&
          (data.label || '').toLowerCase().includes((this.query.label || '').toLowerCase()) &&
          (data.Degree || '').toString().toLowerCase().includes((this.query.degree || '').toLowerCase())
        );
        
        // 检查searchQuery过滤条件
        const searchMatch = !this.searchQuery || (
          (data.name || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
          (data.category || '').toLowerCase().includes(this.searchQuery.toLowerCase()) ||  
          (data.label || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
          (data.Degree || '').toString().toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        
        return queryMatch && searchMatch;
      });
    },
    
    filteredEdgeData() {
      // 检查数据是否已加载
      if (this.dataLoading || !this.edgetableData || this.edgetableData.length === 0) {
        console.log('🔄 [filteredEdgeData] 数据尚未加载，返回空数组');
        return [];
      }
      
      return (this.edgetableData || []).filter(data => {
        // 添加数据有效性检查
        if (!data || typeof data !== 'object') {
          console.warn('⚠️ [filteredEdgeData] 发现无效数据项:', data);
          return false;
        }
        
        // 检查query过滤条件
        const queryMatch = !this.query || (
          (data.source || '').toLowerCase().includes((this.query.source || '').toLowerCase()) &&
          (data.target || '').toLowerCase().includes((this.query.target || '').toLowerCase())
        );
        
        // 检查searchQuery过滤条件
        const searchMatch = !this.searchQuery || (
          (data.source || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
          (data.target || '').toLowerCase().includes(this.searchQuery.toLowerCase())
        );
        
        return queryMatch && searchMatch;
      });
    },
    
    filterEdgeQueryAll() {
      // 检查数据是否已加载
      if (this.dataLoading || !this.edgeSource || this.edgeSource.length === 0) {
        console.log('🔄 [filterEdgeQueryAll] 数据尚未加载，返回空数组');
        return [];
      }

      if (this.queryAll.Source == "" && this.queryAll.Target == "") {

        return (this.edgeSource || []).filter(data => {
          // 添加数据有效性检查
          if (!data || typeof data !== 'object') {
            console.warn('⚠️ [filterEdgeQueryAll] 发现无效数据项:', data);
            return false;
          }
          
          // 检查query过滤条件
          const queryMatch = !this.query || (
            (data.source || '').toLowerCase().includes((this.query.source || '').toLowerCase()) &&
            (data.target || '').toLowerCase().includes((this.query.target || '').toLowerCase())
          );
          
          // 检查searchQuery过滤条件
          const searchMatch = !this.searchQuery || (
            (data.source || '').toLowerCase().includes(this.searchQuery.toLowerCase()) || 
            (data.target || '').toLowerCase().includes(this.searchQuery.toLowerCase())
          );
          
          return queryMatch && searchMatch;
        });
      }

      // 数据格式支持大写和小写字段名（Source/source, Target/target等）
      // 包含字段: Source, Target, Source preferred name, Target preferred name, Interaction, Source group, Target group, Database, Edge type
      return (this.edgeSource || []).filter(data => {
        // 添加数据有效性检查
        if (!data || typeof data !== 'object') {
          console.warn('⚠️ [filterEdgeQueryAll] 发现无效数据项:', data);
          return false;
        }

        // 检查queryAll过滤条件 (支持大写和小写字段名)
        const queryAllMatch = !this.queryAll || (
          ((data.Source || data.source) || '').toLowerCase().includes((this.queryAll.Source || '').toLowerCase()) &&
          ((data.Target || data.target) || '').toLowerCase().includes((this.queryAll.Target || '').toLowerCase()) &&
          ((data['Source preferred name'] || data.source_preferred_name) || '').toLowerCase().includes((this.queryAll.SourcePreferredName || '').toLowerCase()) &&
          ((data['Target preferred name'] || data.target_preferred_name) || '').toLowerCase().includes((this.queryAll.TargetPreferredName || '').toLowerCase()) &&
          ((data.Interaction || data.interaction) || '').toLowerCase().includes((this.queryAll.Interaction || '').toLowerCase()) &&
          ((data['Source group'] || data.source_group) || '').toLowerCase().includes((this.queryAll.SourceGroup || '').toLowerCase()) &&
          ((data['Target group'] || data.target_group) || '').toLowerCase().includes((this.queryAll.TargetGroup || '').toLowerCase()) &&
          ((data.Database || data.database) || '').toLowerCase().includes((this.queryAll.Database || '').toLowerCase()) &&
          ((data['Edge type'] || data.edge_type) || '').toString().toLowerCase().includes((this.queryAll.EdgeType || '').toLowerCase())
        );

        return queryAllMatch;
      });
    },
    
    // 预计算图例样式，避免在模板中频繁调用方法
    // 只在图例和颜色列表存在时计算，减少不必要的计算
    // 3D视图使用colorList3D，2D视图使用colorList
    legendWithStyles() {
      if (!this.legend || this.legend.length === 0) {
        return [];
      }

      // 根据当前视图选择对应的颜色列表
      const currentColorList = this.show3DView ? this.colorList3D : this.colorList;
      if (!currentColorList) {
        return [];
      }

      return this.legend.map((item, index) => {
        const color = currentColorList[index] || '#0bedd3';
        let iconStyle = {};

        if (item.icon === 'triangle') {
          iconStyle = {
            borderBottomColor: color,
            backgroundColor: 'transparent'
          };
        } else {
          // circle 或 diamond
          iconStyle = {
            backgroundColor: color
          };
        }

        return {
          ...item,
          iconStyle
        };
      });
    },
    
    // 边粗细的双向绑定计算属性
    currentEdgeSize: {
      get() {
        return this.show3DView ? this.edgeSize3D : this.edgeSize;
      },
      set(val) {
        if (this.show3DView) {
          this.edgeSize3D = val;
        } else {
          this.edgeSize = val;
        }
      }
    },
    
    // 边透明度的双向绑定计算属性
    currentLineTransparency: {
      get() {
        return this.show3DView ? this.lineTransparency3D : this.lineTransparency;
      },
      set(val) {
        if (this.show3DView) {
          this.lineTransparency3D = val;
        } else {
          this.lineTransparency = val;
        }
      }
    },
    
    // 节点大小的双向绑定计算属性
    currentNodeSize: {
      get() {
        return this.show3DView ? this.nodevSize3D : this.nodevSize;
      },
      set(val) {
        if (this.show3DView) {
          this.nodevSize3D = val;
        } else {
          this.nodevSize = val;
        }
      }
    },
    
    // 节点透明度的双向绑定计算属性
    currentNodeTransparency: {
      get() {
        return this.show3DView ? this.nodeTransparency3D : this.nodeTransparency;
      },
      set(val) {
        if (this.show3DView) {
          this.nodeTransparency3D = val;
        } else {
          this.nodeTransparency = val;
        }
      }
    },
    
    // 标签大小的双向绑定计算属性
    currentLabelSize: {
      get() {
        return this.show3DView ? this.frontSize3D : this.frontSize;
      },
      set(val) {
        if (this.show3DView) {
          this.frontSize3D = val;
        } else {
          this.frontSize = val;
        }
      }
    },
    
    fullscreenButtonRight() {
      const switchButtonRight = 10;
      // 根据屏幕宽度调整：
      // - 小屏幕（< 600px）：将 Fullscreen 按钮放在 Switch 按钮下方
      // - 中等屏幕（600-1600px）：使用固定的较小间距 180px
      // - 大屏幕（>= 1600px）：使用固定的较大间距 240px
      console.log('🔍 [fullscreenButtonRight] windowWidth:', this.windowWidth);
      if (this.windowWidth < 600) {
        // 小屏幕：两个按钮垂直排列，Fullscreen 按钮在下方
        return switchButtonRight;
      } else if (this.windowWidth < 1600) { 
        return 180;
      } else {
        return 185;
      }
    },
    
    // 计算 Fullscreen 按钮的 top 值（小屏幕时放在下方）
    fullscreenButtonTop() {
      if (this.windowWidth < 600) {
        // 小屏幕：放在 Switch 按钮下方（按钮高度约 32px + 10px 间距）
        return 52;
      }
      return 10;
    },
    
    // Vuex状态映射
    ...mapGetters([
      'isLoggedIn',
      'username',
      'sessionUuid'
    ])

  },

  methods: {
    ...mapActions([
      'fetchLoginStatus'
    ]),

    hasColumnData(rows, columnNames) {
      const names = Array.isArray(columnNames) ? columnNames : [columnNames];
      return (rows || []).some(row => {
        if (!row || typeof row !== 'object') return false;
        return names.some(name => {
          if (!Object.prototype.hasOwnProperty.call(row, name)) return false;
          const value = row[name];
          return value !== null && value !== undefined && String(value).trim() !== '';
        });
      });
    },

    normalizeGraphColor(color) {
      if (!color) return color;
      if (String(color).startsWith('rgba')) {
        const rgb = String(color).match(/\d+/g);
        return rgb && rgb.length >= 3 ? `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})` : color;
      }
      if (String(color).length > 7 && String(color).startsWith('#')) {
        return String(color).substring(0, 7);
      }
      return color;
    },

    getExisting2DChart() {
      const mainview = document.getElementById('mainview');
      if (!mainview) return null;
      return this.$echarts.getInstanceByDom(mainview);
    },

    apply2DColorSettings({ includeBackground = false, includeLabel = false } = {}) {
      if (!this.option || !this.option.series || !this.option.series[0]) return;

      this.option.color = this.colorList;
      this.option.series[0].lineStyle = {
        ...(this.option.series[0].lineStyle || {}),
        color: this.linecolor
      };

      if (includeLabel) {
        this.option.series[0].label = {
          ...(this.option.series[0].label || {}),
          color: this.labelColor3D
        };
      }

      if (includeBackground) {
        this.option.backgroundColor = this.backgroundColor3D;
      }

      const myChart = this.getExisting2DChart();
      if (myChart) {
        myChart.setOption(this.option, true);
      }
    },

    apply3DColorSettings({ includeBackground = false, includeLabel = false } = {}) {
      if (!this.graph3D) return;

      this.graph3D
        .nodeColor((node) => this.getNodeColor3D(node))
        .linkColor(() => this.linecolor3D);

      this.graph3D.nodeColor(this.graph3D.nodeColor());
      this.graph3D.linkColor(this.graph3D.linkColor());

      if (includeBackground) {
        this.graph3D.backgroundColor(this.backgroundColor3D);
      }

      if (includeLabel) {
        this.graph3D.nodeThreeObject(this.graph3D.nodeThreeObject());
      }
    },
     
    async fetchUserStatus() {
      console.log('🔍 [fetchUserStatus] 开始获取用户状态信息...');
      
      try {
        // 调用Vuex action获取最新的登录状态
        await this.fetchLoginStatus();
        
        console.log('✅ [fetchUserStatus] 用户状态获取完成:', {
          isLoggedIn: this.isLoggedIn,
          username: this.username || '',
          hasSession: !!this.sessionUuid
        });
        
        // 如果用户未登录，可以显示提示
        if (!this.isLoggedIn) {
          console.warn('⚠️ [fetchUserStatus] 用户未登录状态');
        }
      } catch (error) {
        console.error('💥 [fetchUserStatus] 获取用户状态失败:', error);
      }
    },
    async initializeInjectedData() {
      console.log('🚀 [initializeInjectedData] 使用注入的本地CSV数据初始化图表...');

      if (this.chartTitle) {
        this.title = this.chartTitle;
        document.title = this.chartTitle;
      }

      try {
        // 注入数据（EVIZ 示例/上传）默认按边数比例设置节点大小
        this.nodeType = "2";
        this.nodeType3D = "2";

        await this.handleNetNodeData(this.localNodeCsv);
        await this.handleNetEdgeData(this.localEdgeCsv);
        await this.setLegend();

        this.nodetableData = this.nodes;
        this.edgetableData = this.edges;
        this.configColorList();
        this.nodeLoad = true;
        this.edgeLoad = true;
        this.dataLoading = false;

        if (!this.show3DView) {
          await this.showFigure();
        }

        if (this.show3DView && this.nodes.length > 0) {
          this.$nextTick(() => {
            this.showFigure3D();
          });
        }
      } catch (error) {
        console.error('💥 [initializeInjectedData] 本地CSV图表初始化失败:', error);
        this.dataLoading = false;
        throw error;
      }
    },
    async getAllData() {
      console.log('🚀 [getAllData] ========== 开始获取所有数据 ==========');
      const startTime = Date.now();
      
      try {
        console.log('📝 [getAllData] 步骤 1/5: 获取节点数据...');
      await this.getNodedata()
        console.log('✅ [getAllData] 步骤 1/5: 节点数据获取完成');
        
        console.log('📝 [getAllData] 步骤 2/5: 获取边数据...');
      await this.getEdgedata()
        console.log('✅ [getAllData] 步骤 2/5: 边数据获取完成');
        
        console.log('📝 [getAllData] 步骤 3/5: 设置图例...');
      await this.setLegend()
        console.log('✅ [getAllData] 步骤 3/5: 图例设置完成');
        
        console.log('📝 [getAllData] 步骤 4/5: 显示图表...');
        // 设置表格数据（无论显示哪个视图都需要）
        this.nodetableData = this.nodes;
        this.edgetableData = this.edges;
        console.log('📋 [getAllData] 表格数据已设置:', {
          nodesCount: this.nodetableData.length,
          edgesCount: this.edgetableData.length
        });
        
        // 配置颜色列表（无论显示哪个视图都需要）
        this.configColorList();
        console.log('🎨 [getAllData] 颜色配置完成:', this.colorList);
        
        // 只有在显示2D视图时才初始化2D视图
        if (!this.show3DView) {
          await this.showFigure();
          console.log('✅ [getAllData] 步骤 4/5: 2D图表显示完成');
        } else {
          console.log('⏭️ [getAllData] 步骤 4/5: 跳过2D视图初始化（默认显示3D视图）');
        }
        
        console.log('📝 [getAllData] 步骤 5/5: 设置加载状态...');
      this.nodeLoad = true
      this.dataLoading = false // 数据加载完成
        console.log('✅ [getAllData] 步骤 5/5: 加载状态设置完成');
        
        // 如果默认显示3D视图，在数据加载完成后自动渲染3D图
        if (this.show3DView && this.nodes.length > 0) {
          this.$nextTick(() => {
            // 3D视图使用自己的力导向布局，不依赖2D布局数据，直接渲染
            this.showFigure3D();
          });
        }
        
        const endTime = Date.now();
        console.log('🎉 [getAllData] ========== 所有数据加载完成 ==========', {
          totalTime: `${endTime - startTime}ms`,
          nodesCount: this.nodes.length,
          edgesCount: this.edges.length,
          categoriesCount: this.categories.length,
          nodeLoadStatus: this.nodeLoad
        });
        
      } catch (error) {
        console.error('💥 [getAllData] 数据加载过程中发生错误:', {
          error: error.message,
          stack: error.stack,
          currentStep: '未知步骤'
        });
        this.dataLoading = false // 即使出错也要设置加载状态为完成
        throw error;
      }
    },
    async getNodedata() {
      console.log('🔄 [getNodedata] 开始获取和处理节点数据...');
      try {
      var resData = await this.getNodes()
        console.log('📤 [getNodedata] 节点API调用完成，开始处理数据...');
      await this.handleNetNodeData(resData)
        console.log('✅ [getNodedata] 节点数据处理完成');
      } catch (error) {
        console.error('💥 [getNodedata] 节点数据获取失败:', error);
        throw error;
      }
    },
    async getEdgedata() {
      console.log('🔗 [getEdgedata] 开始获取和处理边数据...');
      try {
      var resData = await this.getEdges()
        console.log('📤 [getEdgedata] 边API调用完成，开始处理数据...');
      await this.handleNetEdgeData(resData)
        console.log('✅ [getEdgedata] 边数据处理完成');
      } catch (error) {
        console.error('💥 [getEdgedata] 边数据获取失败:', error);
        throw error;
      }
    },
    handleNetNodeData(data) {
      console.log('🔧 [handleNetNodeData] 开始处理节点数据...');
      console.log('📊 [handleNetNodeData] 原始CSV数据信息:', {
        dataType: typeof data,
        dataLength: data ? data.length : 0,
        preview: data ? data.substring(0, 150) + '...' : 'No data'
      });
      
      this.netNodes = data
      var retList;
      
      console.log('📋 [handleNetNodeData] 开始Papa.parse解析CSV...');
      Papa.parse(this.netNodes, {
        complete: function (results) {
          retList = results.data
          // 结果: [ ["col1", "col2", "col3"], ["val1", "val2", "val3"], ["val4", "val5", "val6"] ]
        }
      });
      
      console.log('📋 [handleNetNodeData] Papa.parse解析完成:', {
        rowsCount: retList ? retList.length : 0,
        columnsCount: retList && retList[0] ? retList[0].length : 0,
        headers: retList && retList[0] ? retList[0] : [],
        sampleRow: retList && retList[1] ? retList[1] : []
      });
      
      if (retList && retList.length > 0) {
        const lastRow = retList[retList.length - 1];
        const isEmptyLastRow = Array.isArray(lastRow) && lastRow.every(cell => cell === '' || cell === null || cell === undefined);
        if (isEmptyLastRow) {
          retList.pop();
        }
      }
      console.log('🧹 [handleNetNodeData] 移除空行后行数:', retList.length);
      
      var result = [];
      for (var i = 1; i < retList.length; i++) {
        var obj = {};
        for (var j = 0; j < retList[0].length; j++) {
          obj[retList[0][j]] = retList[i][j];
        }
        result.push(obj);
      }
      
      this.nodeSource = result
      console.log('📊 [handleNetNodeData] nodeSource转换完成:', {
        nodeSourceLength: this.nodeSource.length,
        sampleNode: this.nodeSource[0] || {},
        nodeSourceKeys: this.nodeSource[0] ? Object.keys(this.nodeSource[0]) : []
      });
      
      this.nodes = []
      const usedIds = new Set() // 用于跟踪已使用的ID
      
      for (var k = 0; k < this.nodeSource.length; k++) {
        var nodeSig = {}
        // 添加防护性检查，确保字段存在
        let nodeId = this.nodeSource[k]['EXID'] || ''
        let nodeCategory = this.nodeSource[k]['Group name'] || ''
        
        // 如果ID已存在，添加类别后缀使其唯一
        if (usedIds.has(nodeId)) {
          nodeId = `${nodeId}_${nodeCategory}`
          console.warn(`⚠️ [handleNetNodeData] 发现重复节点ID，已添加类别后缀: ${this.nodeSource[k]['EXID']} -> ${nodeId}`)
        }
        usedIds.add(nodeId)
        
        nodeSig['id'] = nodeId
        nodeSig['name'] = nodeId
        nodeSig['label'] = this.nodeSource[k]['Preferred name'] || ''
        nodeSig['category'] = nodeCategory
        // 新数据格式中Degree字段位置不同
        nodeSig['Degree'] = Number(this.nodeSource[k]['Degree'] || 0)
        this.nodeSource[k]['Degree'] = Number(this.nodeSource[k]['Degree'] || 0)
        this.nodes.push(nodeSig)
      }
      
      console.log('✅ [handleNetNodeData] nodes数组构建完成:', {
        nodesLength: this.nodes.length,
        sampleNode: this.nodes[0] || {},
        nodeKeys: this.nodes[0] ? Object.keys(this.nodes[0]) : [],
        categoryStats: this.nodes.reduce((acc, node) => {
          const category = node.category || 'Unknown';
          acc[category] = (acc[category] || 0) + 1;
          return acc;
        }, {}),
        uniqueIds: new Set(this.nodes.map(n => n.id)).size,
        totalIds: this.nodes.length
      });
    },
    handleNetEdgeData(data) {
      console.log('🔗 [handleNetEdgeData] 开始处理边数据...');
      console.log('📊 [handleNetEdgeData] 原始CSV数据信息:', {
        dataType: typeof data,
        dataLength: data ? data.length : 0,
        preview: data ? data.substring(0, 150) + '...' : 'No data'
      });
      
      this.netEdges = data
      var retList;
      
      console.log('📋 [handleNetEdgeData] 开始Papa.parse解析CSV...');
      Papa.parse(this.netEdges, {
        complete: function (results) {
          retList = results.data
          // 结果: [ ["col1", "col2", "col3"], ["val1", "val2", "val3"], ["val4", "val5", "val6"] ]
        }
      });
      
      console.log('📋 [handleNetEdgeData] Papa.parse解析完成:', {
        rowsCount: retList ? retList.length : 0,
        columnsCount: retList && retList[0] ? retList[0].length : 0,
        headers: retList && retList[0] ? retList[0] : [],
        sampleRow: retList && retList[1] ? retList[1] : []
      });
      
      if (retList && retList.length > 0) {
        const lastRow = retList[retList.length - 1];
        const isEmptyLastRow = Array.isArray(lastRow) && lastRow.every(cell => cell === '' || cell === null || cell === undefined);
        if (isEmptyLastRow) {
          retList.pop();
        }
      }
      console.log('🧹 [handleNetEdgeData] 移除空行后行数:', retList.length);
      
      var result = [];
      for (var i = 1; i < retList.length; i++) {
        var obj = {};
        for (var j = 0; j < retList[0].length; j++) {
          obj[retList[0][j]] = retList[i][j];
        }
        result.push(obj);
      }
      
      this.edgeSource = result
      console.log('📊 [handleNetEdgeData] edgeSource转换完成:', {
        edgeSourceLength: this.edgeSource.length,
        sampleEdge: this.edgeSource[0] || {},
        edgeSourceKeys: this.edgeSource[0] ? Object.keys(this.edgeSource[0]) : []
      });
      
      this.edges = []
      // 创建节点ID映射，用于更新边的引用
      const nodeIdMap = new Map()
      this.nodes.forEach(node => {
        const originalId = node.id.split('_')[0] // 获取原始ID（去掉类别后缀）
        if (!nodeIdMap.has(originalId)) {
          nodeIdMap.set(originalId, [])
        }
        nodeIdMap.get(originalId).push(node)
      })
      
      console.log('🔍 [handleNetEdgeData] 节点ID映射创建完成:', {
        nodeIdMapSize: nodeIdMap.size,
        sampleNodeIds: Array.from(nodeIdMap.keys()).slice(0, 5),
        totalNodes: this.nodes.length,
        sampleNodes: this.nodes.slice(0, 3).map(n => ({ id: n.id, originalId: n.id.split('_')[0] }))
      });
      
      let validEdges = 0;
      let invalidSourceEdges = 0;
      let invalidTargetEdges = 0;
      
      for (var k = 0; k < this.edgeSource.length; k++) {
        var edgeSig = {}
        // 添加防护性检查，确保字段存在
        // 注意：边数据中的字段名可能是大写或小写
        const sourceId = this.edgeSource[k]['source'] || this.edgeSource[k]['Source'] || ''
        const targetId = this.edgeSource[k]['target'] || this.edgeSource[k]['Target'] || ''
        
        // 调试：显示前几个边的ID信息
        if (k < 3) {
          console.log(`🔍 [handleNetEdgeData] 边 ${k} ID信息:`, {
            sourceId: sourceId,
            targetId: targetId,
            edgeDataKeys: Object.keys(this.edgeSource[k]),
            hasSource: !!this.edgeSource[k]['source'],
            hasSourceCapital: !!this.edgeSource[k]['Source'],
            hasTarget: !!this.edgeSource[k]['target'],
            hasTargetCapital: !!this.edgeSource[k]['Target']
          });
        }
        
        // 查找对应的节点ID
        const sourceNodes = nodeIdMap.get(sourceId) || []
        const targetNodes = nodeIdMap.get(targetId) || []
        
        if (sourceNodes.length === 0) {
          invalidSourceEdges++;
          if (invalidSourceEdges <= 5) { // 只显示前5个错误
            console.warn(`⚠️ [handleNetEdgeData] 找不到源节点: ${sourceId}`, {
              availableNodeIds: Array.from(nodeIdMap.keys()).slice(0, 10),
              edgeData: this.edgeSource[k]
            });
          }
          continue
        }
        if (targetNodes.length === 0) {
          invalidTargetEdges++;
          if (invalidTargetEdges <= 5) { // 只显示前5个错误
            console.warn(`⚠️ [handleNetEdgeData] 找不到目标节点: ${targetId}`, {
              availableNodeIds: Array.from(nodeIdMap.keys()).slice(0, 10),
              edgeData: this.edgeSource[k]
            });
          }
          continue
        }
        
        // 如果有多于一个节点，选择第一个（或者可以根据需要选择特定的）
        edgeSig['source'] = sourceNodes[0].id
        edgeSig['target'] = targetNodes[0].id
        this.edges.push(edgeSig)
        validEdges++;
      }

      // 节点CSV通常不含Degree列，这里根据已构建的边列表统计每个节点的度，
      // 并回写到nodes与nodeSource，保证表格Degree列显示正确的连边数量
      const degreeMap = new Map()
      this.edges.forEach(edge => {
        if (edge.source) degreeMap.set(edge.source, (degreeMap.get(edge.source) || 0) + 1)
        if (edge.target) degreeMap.set(edge.target, (degreeMap.get(edge.target) || 0) + 1)
      })
      for (var d = 0; d < this.nodes.length; d++) {
        const degree = degreeMap.get(this.nodes[d].id) || 0
        this.nodes[d]['Degree'] = degree
        if (this.nodeSource[d]) {
          this.nodeSource[d]['Degree'] = degree
        }
      }
      console.log('📊 [handleNetEdgeData] Degree统计完成:', {
        nodesWithDegree: degreeMap.size,
        maxDegree: degreeMap.size ? Math.max(...degreeMap.values()) : 0
      });

      console.log('📊 [handleNetEdgeData] 边处理统计:', {
        totalEdges: this.edgeSource.length,
        validEdges: validEdges,
        invalidSourceEdges: invalidSourceEdges,
        invalidTargetEdges: invalidTargetEdges,
        successRate: `${((validEdges / this.edgeSource.length) * 100).toFixed(2)}%`
      });
      
      console.log('✅ [handleNetEdgeData] edges数组构建完成:', {
        edgesLength: this.edges.length,
        sampleEdge: this.edges[0] || {},
        edgeKeys: this.edges[0] ? Object.keys(this.edges[0]) : [],
        uniqueSources: [...new Set(this.edges.map(e => e.source))].length,
        uniqueTargets: [...new Set(this.edges.map(e => e.target))].length,
        validEdges: this.edges.filter(e => e.source && e.target).length
      });
    },
    async getNodes() {
      console.log('🔄 [getNodes] 开始获取节点数据...');
      
      const urlParams = new URLSearchParams(window.location.search);
      this.redirectSession = String(urlParams.get('session'));
      this.netDataType = String(urlParams.get('mode') || "");
      
      console.log('📋 [getNodes] URL参数解析结果:', {
        session: this.redirectSession,
        mode: this.netDataType,
        fullUrl: window.location.href
      });
      
      if (this.netDataType) {
        this.title = this.title + "-" + this.netDataType
        document.title = this.title
        console.log('📝 [getNodes] 页面标题已更新:', this.title);
      }
      
      const payload = {
        session: this.redirectSession,
        mode: this.netDataType,
        type: 'node',
        format_json: false
      };
      
      console.log('📤 [getNodes] 发送API请求:', {
        url: '/api/ebio/showModelGraph/',
        payload: payload
      });
      
      try {
        const startTime = Date.now();
        
        // 构建请求头，包含用户认证信息
        const headers = {
          'Content-Type': 'application/json',
        };
        
        // 如果有用户token，添加到请求头
        const access_token = localStorage.getItem('access_token');
        if (access_token) {
          headers['Authorization'] = `Bearer ${access_token}`;
        }
        
        const response = await axios.post('/api/ebio/showModelGraph/', payload, {
          headers: headers
        });
        const endTime = Date.now();
        
        console.log('📥 [getNodes] API响应接收完成:', {
          responseTime: `${endTime - startTime}ms`,
          status: response.status,
          statusText: response.statusText,
          success: response.data.success,
          message: response.data.message || 'No message'
        });
        
        if (response.data.success) {
          const csvContent = response.data.csv_content;
          const csvLength = csvContent ? csvContent.length : 0;
          const csvPreview = csvContent ? csvContent.substring(0, 200) + '...' : 'No content';
          
          console.log('✅ [getNodes] CSV数据获取成功:', {
            dataLength: csvLength,
            dataType: typeof csvContent,
            linesCount: csvContent ? csvContent.split('\n').length : 0,
            preview: csvPreview,
            fullResponseKeys: Object.keys(response.data)
          });
          
          return csvContent;
        } else {
          console.error('❌ [getNodes] API返回失败:', response.data);
          throw new Error(response.data.message || 'Failed to get node data');
        }
      } catch (error) {
        console.error('💥 [getNodes] 请求发生错误:', {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          responseData: error.response?.data,
          stack: error.stack
        });
        throw error;
      }
    },
    async getEdges() {
      console.log('🔗 [getEdges] 开始获取边数据...');
      
      const urlParams = new URLSearchParams(window.location.search);
      this.redirectSession = String(urlParams.get('session'));
      this.netDataType = String(urlParams.get('mode') || "");
      
      console.log('📋 [getEdges] URL参数解析结果:', {
        session: this.redirectSession,
        mode: this.netDataType,
        fullUrl: window.location.href
      });
      
      const payload = {
        session: this.redirectSession,
        mode: this.netDataType,
        type: 'edge',
        format_json: false
      };
      
      console.log('📤 [getEdges] 发送API请求:', {
        url: '/api/ebio/showModelGraph/',
        payload: payload
      });
      
      try {
        const startTime = Date.now();
        
        // 构建请求头，包含用户认证信息
        const headers = {
          'Content-Type': 'application/json',
        };
        
        // 如果有用户token，添加到请求头
        const access_token = localStorage.getItem('access_token');
        if (access_token) {
          headers['Authorization'] = `Bearer ${access_token}`;
        }
        
        const response = await axios.post('/api/ebio/showModelGraph/', payload, {
          headers: headers
        });
        const endTime = Date.now();
        
        console.log('📥 [getEdges] API响应接收完成:', {
          responseTime: `${endTime - startTime}ms`,
          status: response.status,
          statusText: response.statusText,
          success: response.data.success,
          message: response.data.message || 'No message'
        });
        
        if (response.data.success) {
          const csvContent = response.data.csv_content;
          const csvLength = csvContent ? csvContent.length : 0;
          const csvPreview = csvContent ? csvContent.substring(0, 200) + '...' : 'No content';
          
          console.log('✅ [getEdges] CSV数据获取成功:', {
            dataLength: csvLength,
            dataType: typeof csvContent,
            linesCount: csvContent ? csvContent.split('\n').length : 0,
            preview: csvPreview,
            fullResponseKeys: Object.keys(response.data)
          });
          
          return csvContent;
        } else {
          console.error('❌ [getEdges] API返回失败:', response.data);
          throw new Error(response.data.message || 'Failed to get edge data');
        }
      } catch (error) {
        console.error('💥 [getEdges] 请求发生错误:', {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          responseData: error.response?.data,
          stack: error.stack
        });
        throw error;
      }
    },

    buildExportFileName(extension) {
      if (this.hasInjectedCsvData) {
        const baseName = (this.chartTitle || 'EVIZ_network')
          .replace(/[^a-zA-Z0-9_-]+/g, '_')
          .replace(/^_+|_+$/g, '') || 'EVIZ_network';
        return `${baseName}.${extension}`;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const rawMode = (urlParams.get('mode') || '').toString().trim();
      const modeMap = {
        eppd: 'EPPD',
        epd: 'EPD',
        egod: 'EGoD',
        eged: 'EGeD',
        epad: 'EPaD'
      };
      const normalized = rawMode.toLowerCase();
      const mode = modeMap[normalized] || rawMode || 'unknown';
      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const dd = String(now.getDate()).padStart(2, '0');
      return `EBIO_${mode}_${yyyy}${mm}${dd}.${extension}`;
    },
    saveView() {
      let fileName = this.buildExportFileName('png');
      // 如果是3D视图，在文件名中添加3d后缀
      if (this.show3DView) {
        fileName = fileName.replace(/\.png$/, '_3d.png');
      }
      
      // 如果是3D视图，从WebGL canvas导出
      if (this.show3DView && this.graph3D) {
        try {
          let renderer = null;
          let canvas = null;
          
          if (this.graph3D.renderer && this.graph3D.renderer.domElement) {
            renderer = this.graph3D.renderer;
            canvas = renderer.domElement;
          } else if (typeof this.graph3D.renderer === 'function') {
            renderer = this.graph3D.renderer();
            if (renderer && renderer.domElement) {
              canvas = renderer.domElement;
            }
          }
          
          if (!canvas) {
            const container = document.getElementById('mainview3d');
            if (container) {
              canvas = container.querySelector('canvas');
              if (canvas && !renderer && this.graph3D.renderer) {
                renderer = this.graph3D.renderer;
              }
            }
          }
          
          if (!canvas) {
            this.$message.error('导出失败：无法获取3D图形数据');
            return;
          }
          
          let gl = null;
          if (renderer && typeof renderer.getContext === 'function') {
            gl = renderer.getContext();
          } else if (canvas) {
            gl = canvas.getContext('webgl') || canvas.getContext('webgl2');
          }
          
          if (!gl) {
            this.$message.error('导出失败：无法获取WebGL上下文');
            return;
          }
          
          const width = canvas.width || gl.drawingBufferWidth;
          const height = canvas.height || gl.drawingBufferHeight;
          
          const preserveDrawingBuffer = gl.getParameter ? gl.getParameter(gl.PRESERVE_DRAWING_BUFFER) : false;
          if (!preserveDrawingBuffer && renderer && typeof renderer.render === 'function') {
            const scene = this.graph3D.scene ? this.graph3D.scene() : null;
            const camera = this.graph3D.camera ? this.graph3D.camera() : null;
            if (scene && camera) {
              renderer.render(scene, camera);
            }
          }
          
          const pixels = new Uint8Array(width * height * 4);
          gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
          
          const tempCanvas = document.createElement('canvas');
          tempCanvas.width = width;
          tempCanvas.height = height;
          const tempCtx = tempCanvas.getContext('2d');
          const imageData = tempCtx.createImageData(width, height);
          
          for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
              const srcIndex = ((height - 1 - y) * width + x) * 4;
              const dstIndex = (y * width + x) * 4;
              imageData.data[dstIndex] = pixels[srcIndex];
              imageData.data[dstIndex + 1] = pixels[srcIndex + 1];
              imageData.data[dstIndex + 2] = pixels[srcIndex + 2];
              imageData.data[dstIndex + 3] = pixels[srcIndex + 3];
            }
          }
          
          tempCtx.putImageData(imageData, 0, 0);
          
          const pixelRatio = 2;
          const exportCanvas = document.createElement('canvas');
          exportCanvas.width = width * pixelRatio;
          exportCanvas.height = height * pixelRatio;
          const exportCtx = exportCanvas.getContext('2d');
          
          exportCtx.fillStyle = '#ffffff';
          exportCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
          exportCtx.drawImage(tempCanvas, 0, 0, width, height, 0, 0, exportCanvas.width, exportCanvas.height);
          
          exportCanvas.toBlob((blob) => {
            if (blob) {
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              a.click();
              URL.revokeObjectURL(url);
            } else {
              this.$message.error('导出失败：无法创建图片文件');
            }
          }, 'image/png');
        } catch (error) {
          this.$message.error('导出失败：' + error.message);
        }
        return;
      }
      
      // 2D视图：使用ECharts导出
      var img = new Image();
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      img.src = myChart.getDataURL({
        type: "png",
        pixelRatio: 2, //放大2倍
        backgroundColor: "#fff",
      });
      img.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        var event = new MouseEvent("click");
        a.download = fileName;
        // 将生成的URL设置为a.href属性
        a.href = dataURL;
        // 触发a的单击事件
        a.dispatchEvent(event);
        a.remove();
      };
    },
    saveViewSvg() {
      let fileName = this.buildExportFileName('svg');
      // 如果是3D视图，在文件名中添加3d后缀
      if (this.show3DView) {
        fileName = fileName.replace(/\.svg$/, '_3d.svg');
      }
      
      // 如果是3D视图，将WebGL canvas转换为SVG
      if (this.show3DView && this.graph3D) {
        try {
          let renderer = null;
          let canvas = null;
          
          if (this.graph3D.renderer && this.graph3D.renderer.domElement) {
            renderer = this.graph3D.renderer;
            canvas = renderer.domElement;
          } else if (typeof this.graph3D.renderer === 'function') {
            renderer = this.graph3D.renderer();
            if (renderer && renderer.domElement) {
              canvas = renderer.domElement;
            }
          }
          
          if (!canvas) {
            const container = document.getElementById('mainview3d');
            if (container) {
              canvas = container.querySelector('canvas');
              if (canvas && !renderer && this.graph3D.renderer) {
                renderer = this.graph3D.renderer;
              }
            }
          }
          
          if (!canvas) {
            this.$message.error('导出失败：无法获取3D图形数据');
            return;
          }
          
          let gl = null;
          if (renderer && typeof renderer.getContext === 'function') {
            gl = renderer.getContext();
          } else if (canvas) {
            gl = canvas.getContext('webgl') || canvas.getContext('webgl2');
          }
          
          if (!gl) {
            this.$message.error('导出失败：无法获取WebGL上下文');
            return;
          }
          
          const pixelWidth = canvas.width || gl.drawingBufferWidth;
          const pixelHeight = canvas.height || gl.drawingBufferHeight;
          const displayWidth = canvas.clientWidth || pixelWidth;
          const displayHeight = canvas.clientHeight || pixelHeight;
          
          const preserveDrawingBuffer = gl.getParameter ? gl.getParameter(gl.PRESERVE_DRAWING_BUFFER) : false;
          if (!preserveDrawingBuffer && renderer && typeof renderer.render === 'function') {
            const scene = this.graph3D.scene ? this.graph3D.scene() : null;
            const camera = this.graph3D.camera ? this.graph3D.camera() : null;
            if (scene && camera) {
              renderer.render(scene, camera);
            }
          }
          
          const tempCanvas = document.createElement('canvas');
          tempCanvas.width = pixelWidth;
          tempCanvas.height = pixelHeight;
          const tempCtx = tempCanvas.getContext('2d');
          const pixels = new Uint8Array(pixelWidth * pixelHeight * 4);
          gl.readPixels(0, 0, pixelWidth, pixelHeight, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
          
          const imageData = tempCtx.createImageData(pixelWidth, pixelHeight);
          for (let y = 0; y < pixelHeight; y++) {
            for (let x = 0; x < pixelWidth; x++) {
              const srcIndex = ((pixelHeight - 1 - y) * pixelWidth + x) * 4;
              const dstIndex = (y * pixelWidth + x) * 4;
              imageData.data[dstIndex] = pixels[srcIndex];
              imageData.data[dstIndex + 1] = pixels[srcIndex + 1];
              imageData.data[dstIndex + 2] = pixels[srcIndex + 2];
              imageData.data[dstIndex + 3] = pixels[srcIndex + 3];
            }
          }
          
          tempCtx.fillStyle = '#ffffff';
          tempCtx.fillRect(0, 0, pixelWidth, pixelHeight);
          tempCtx.putImageData(imageData, 0, 0);
          
          const canvasDataUrl = tempCanvas.toDataURL('image/png', 0.95);
          const svgDataString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${displayWidth}" height="${displayHeight}" viewBox="0 0 ${displayWidth} ${displayHeight}">
  <rect width="100%" height="100%" fill="#ffffff"/>
  <image x="0" y="0" width="${displayWidth}" height="${displayHeight}" xlink:href="${canvasDataUrl}"/>
</svg>`;
          const svgDataUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgDataString);
          const a = document.createElement('a');
          a.href = svgDataUrl;
          a.download = fileName;
          a.click();
        } catch (error) {
          this.$message.error('导出失败：' + error.message);
        }
        return;
      }
      
      // 2D视图：使用ECharts导出
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      var svgDataString = myChart.renderToSVGString();

      // 修复 svgDataString
      if (!svgDataString.startsWith('<svg')) {
        svgDataString = `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400" viewBox="0 0 600 400">${svgDataString}</svg>`;
        console.log("do svg")
      }

      // 创建 Base64 编码的 data URL
      var svgDataUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgDataString);
      var a = document.createElement('a');
      a.href = svgDataUrl;
      a.download = fileName;
      a.click();
    },
    changeNodeType(val) {
      if (this.show3DView) {
        // 3D视图：更新3D节点类型，不影响2D
        this.nodeType3D = val;
        
        // 如果切换到按边数比例模式，需要重新计算节点大小
        if (this.nodeType3D == "2") {
          this.readSymbolSize3D();
          // 清除缓存，确保使用最新的节点数据（包括value属性）重新渲染
          this._cachedGDataBase = null;
          this._cachedNodesLength = null;
          this._cachedEdgesLength = null;
          this._cachedFirstNodeId = null;
          this._cachedLastNodeId = null;
          this._cachedFirstEdgeSource = null;
        }
        
        // 重新渲染整个3D图形以应用新的节点大小设置
        // 这样可以确保gData中的节点包含最新的value属性
        console.log('🔄 [changeNodeType] 重新渲染3D图形以应用新的节点类型...');
        this.showFigure3D();
        
        console.log('✅ [changeNodeType] 3D节点类型已更新:', {
          nodeType3D: this.nodeType3D,
          mode: this.nodeType3D == "1" ? '固定大小' : '按边数比例'
        });
      } else {
        // 2D视图：更新2D节点类型，不影响3D
        this.nodeType = val;
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.dispatchAction({
          type: 'restore'
        })
        this.restoreFigure();
      }
    },
    changeNodeNameType(val) {
      console.log('🔄 [changeNodeNameType] 节点名称类型已更改:', val);
      
      if (this.show3DView) {
        // 3D视图：更新3D节点名称类型，不影响2D
        this.nodeNameType3D = val;
        
        // 更新3D图形标签
        if (this.graph3D) {
          console.log('🔄 [changeNodeNameType] 更新 3D 图形标签...', {
            nodeNameType3D: this.nodeNameType3D,
            nameType: String(this.nodeNameType3D),
            willShow: String(this.nodeNameType3D) === "1" ? 'EXID (name)' : 'Preferred name (label)'
          });
          // 重新设置 nodeLabel 和 nodeThreeObject 中的标签
          const getNodeLabel = (node) => {
            const nameType = String(this.nodeNameType3D);
            if (nameType === "1") {
              return node.name || node.id || '';
            } else {
              return node.label || node.name || node.id || '';
            }
          };
          this.graph3D.nodeLabel(getNodeLabel);
          
          // 同时更新nodeThreeObject中的文本标签
          const getNodeLabelForSprite = (node) => {
            const nameType = String(this.nodeNameType3D);
            if (nameType === "1") {
              return node.name || node.id || '';
            } else {
              return node.label || node.name || node.id || '';
            }
          };
          
          // 重新设置nodeThreeObject以更新文本精灵
          this.graph3D.nodeThreeObject(node => {
            const sprite = new SpriteText(getNodeLabelForSprite(node));
            sprite.material.depthWrite = false;
            sprite.color = this.labelColor3D;
            sprite.textHeight = this.frontSize3D;
            sprite.center.y = 0;
            sprite.center.x = 1.5;
            return sprite;
          });
          
          console.log('✅ [changeNodeNameType] 3D 图形标签已更新');
        }
      } else {
        // 2D视图：更新2D节点名称类型，不影响3D
        this.nodeNameType = val;
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.setOption(this.option, true);
      }
    },
    restoreView() {
      // 如果是3D视图，重新渲染整个3D图形以恢复到初始位置
      if (this.show3DView && this.graph3D) {
        try {
          console.log('🔄 [restoreView] 开始重新渲染3D图形以恢复初始位置...');
          
          // 清除缓存，确保使用原始数据重新渲染
          this._cachedGDataBase = null;
          this._cachedNodesLength = null;
          this._cachedEdgesLength = null;
          this._cachedFirstNodeId = null;
          this._cachedLastNodeId = null;
          this._cachedFirstEdgeSource = null;
          
          // 重新渲染3D图形，这会重新运行物理引擎并恢复到初始布局
          this.showFigure3D();
          
          console.log('✅ [restoreView] 3D图形已重新渲染，正在恢复到初始位置...');
          this.$message.success('正在恢复图形到初始位置...');
        } catch (error) {
          console.error('💥 [restoreView] 3D图形恢复出错:', error);
          this.$message.error('恢复失败：' + error.message);
        }
        return;
      }
      
      // 2D视图：使用ECharts恢复
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      myChart.dispatchAction({
        type: 'restore'
      })
      this.restoreFigure();
    },
    // 获取3D节点的颜色，使用独立的3D颜色列表，并应用透明度
    getNodeColor3D(node) {
      const category = node.group || node.category;
      let baseColor = null;

      if (!category) {
        baseColor = '#0bedd3'; // 默认颜色
      } else {
        // 查找 category 在 this.categories 中的索引
        const categoryIndex = this.categories.findIndex(cat => cat.name === category);

        if (categoryIndex !== -1 && this.colorList3D[categoryIndex]) {
          baseColor = this.colorList3D[categoryIndex];
        } else {
          const overrides = this.categoryColorOverrides || {};
          if (Object.prototype.hasOwnProperty.call(overrides, category)) {
            baseColor = overrides[category];
            return this.normalizeGraphColor(baseColor);
          }
          // 如果找不到，使用 configColorList 的逻辑来获取颜色
          const categoryLower = category.toLowerCase();
          const type = categoryLower.split(" ")[0];

          // 检查是否是 protein 类型
          if (this.proteinColorList[type]) {
            baseColor = this.proteinColorList[type];
          } else if (categoryLower.startsWith('exposure')) {
            baseColor = "#0700d3";
          } else if (categoryLower.startsWith('disease')) {
            baseColor = "#d30004";
          } else {
            baseColor = "#0bedd3"; // 默认颜色
          }
        }
      }

      // 应用3D节点透明度
      // 提取基础颜色（去掉现有的透明度），然后应用当前的透明度设置
      let rgbColor = baseColor;
      if (baseColor.startsWith('rgba')) {
        const rgb = baseColor.match(/\d+/g);
        rgbColor = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
      } else if (baseColor.length > 7) {
        rgbColor = baseColor.substring(0, 7);
      }
      
      // 返回基础颜色（不带透明度）
      // 透明度通过nodeOpacity方法统一设置，不需要在这里应用
      return rgbColor;
    },
    changeNodeColorList(color, index) {
      if (!color) return;

      const baseColor = this.normalizeGraphColor(color);

      this.colorList[index] = color;

      if (this.colorList3D.length !== this.colorList.length) {
        this.colorList3D = this.colorList.map(item => this.normalizeGraphColor(item));
      }
      this.colorList3D[index] = baseColor;

      if (!this.colorList3DBase || this.colorList3DBase.length !== this.colorList3D.length) {
        this.colorList3DBase = new Array(this.colorList3D.length).fill('#000000');
      }
      this.colorList3DBase[index] = baseColor;

      this.apply2DColorSettings();
      this.apply3DColorSettings();
    },
    changeBackgroundColor3D(val) {
      if (!val) return;
      this.backgroundColor3D = val;
      this.apply2DColorSettings({ includeBackground: true });
      this.apply3DColorSettings({ includeBackground: true });
    },
    changeLabelColor3D(val) {
      if (!val) return;
      this.labelColor3D = val;
      this.apply2DColorSettings({ includeLabel: true });
      this.apply3DColorSettings({ includeLabel: true });
    },
    lineColorChange(val) {
      if (!val) return;
      this.linecolor = val;
      this.linecolor3D = val;
      this.apply2DColorSettings();
      this.apply3DColorSettings();
    },
    changeSlider(val) {
      if (this.show3DView) {
        // 3D视图：更新3D节点大小
        // 值已经通过计算属性currentNodeSize的setter自动更新
        if (this.graph3D) {
          if (this.nodeType3D == "1") {
            // 固定大小模式：使用nodeRelSize
            // 3d-force-graph使用nodeRelSize设置节点相对大小
            // nodeRelSize的值需要根据nodevSize3D计算
            // 默认nodeRelSize是6，对应nodevSize为10，所以比例是0.6
            const nodeRelSize = (val / 10) * 6;
            this.graph3D.nodeRelSize(nodeRelSize);
            
            // 强制刷新：通过重新调用nodeRelSize来触发图形更新
            this.graph3D.nodeRelSize(this.graph3D.nodeRelSize());
          } else {
            // 按边数比例模式：更新缩放因子，重新计算节点大小
            // nodevSize3D已经通过currentNodeSize的setter自动更新
            this.nodeScaleFactor3D = val / 10;
            this.readSymbolSize3D();
            
            // 更新gData中的节点value属性，确保graph3D使用最新的节点大小
            const currentGraphData = this.graph3D.graphData();
            if (currentGraphData && currentGraphData.nodes) {
              currentGraphData.nodes.forEach(node => {
                const nodeData = this.nodes.find(n => n.id === node.id);
                if (nodeData && nodeData.value !== undefined) {
                  node.value = nodeData.value;
                }
              });
              // 重新设置graphData以触发更新
              this.graph3D.graphData(currentGraphData);
            }
            
            // 更新nodeVal以应用新的节点大小
            this.graph3D.nodeVal(node => {
              // 优先从节点对象本身获取value（gData中的节点）
              let nodeValue = node.value;
              
              // 如果节点对象没有value，从this.nodes查找
              if (nodeValue === undefined) {
                const nodeData = this.nodes.find(n => n.id === node.id);
                if (nodeData && nodeData.value !== undefined) {
                  nodeValue = nodeData.value;
                }
              }
              
              if (nodeValue !== undefined) {
                // value已经是计算好的3D节点大小，直接返回
                // 确保最小值为4，保证节点可见
                return Math.max(nodeValue, 4);
              }
              
              return 6; // 默认值
            });
            
            // 强制刷新：通过重新调用nodeVal来触发图形更新
            this.graph3D.nodeVal(this.graph3D.nodeVal());
          }
        }
      } else {
        // 2D视图：更新2D节点大小
        if (this.nodeType == 1) {
          this.option.series[0].symbolSize = val;
          // this.option.series[0].lineStyle.width = val / 4;
          const myChart = this.getOrCreateChart();
          if (!myChart) return;
          myChart.setOption(this.option, true)
        }
        if (this.nodeType == 2) {
          this.nodeScaleFactor = val / 10
          this.readSymbolSize()
          // 更新 option 中的节点数据，保持位置信息
          if (this.option.series[0].layout === 'none' && this.model && this.model.length > 0) {
            // 如果使用固定布局，需要保持节点位置
            const nodesWithPosition = JSON.parse(JSON.stringify(this.nodes));
            for (let i in nodesWithPosition) {
              if (this.model[i]) {
                nodesWithPosition[i]['x'] = this.model[i][0]
                nodesWithPosition[i]['y'] = this.model[i][1]
              }
            }
            this.option.series[0].data = nodesWithPosition;
          } else {
            // 否则直接更新节点数据
            this.option.series[0].data = JSON.parse(JSON.stringify(this.nodes));
          }
          const myChart = this.getOrCreateChart();
          if (!myChart) return;
          myChart.setOption(this.option, true)
        }
      }
    },
    changeNodeTransparency(val) {
      if (this.show3DView) {
        // 3D视图：更新3D节点透明度
        // 值已经通过计算属性currentNodeTransparency的setter自动更新
        // getNodeColor3D方法会统一应用透明度，所以这里只需要触发更新
        if (this.graph3D) {
          // 更新节点透明度
          const opacity = 1 - val / 100;
          this.graph3D.nodeOpacity(opacity);
          
          // 重新设置nodeColor函数以触发更新
          // getNodeColor3D会读取最新的nodeTransparency3D并应用透明度
          this.graph3D.nodeColor((node) => this.getNodeColor3D(node));
          
          // 强制刷新：通过重新调用nodeColor和nodeOpacity来触发图形更新
          this.graph3D.nodeColor(this.graph3D.nodeColor());
          this.graph3D.nodeOpacity(this.graph3D.nodeOpacity());
        }
      } else {
        // 2D视图：更新2D节点透明度
        for (var i = 0; i < this.colorList.length; i++) {
          this.colorList[i] = chroma(this.colorList[i]).alpha(1 - val / 100).css('rgba');
        }
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.setOption(this.option, true);
      }
    },
    changeLineTransparency(val) {
      // 值已经通过计算属性currentLineTransparency的setter自动更新
      if (this.show3DView) {
        // 3D视图：更新3D视图边透明度
        if (this.graph3D) {
          // 3d-force-graph使用linkOpacity设置透明度
          const opacity = 1 - val / 100;
          this.graph3D.linkOpacity(opacity);
          
          // 强制刷新：通过重新调用linkOpacity来触发图形更新
          this.graph3D.linkOpacity(this.graph3D.linkOpacity());
        }
      } else {
        // 2D视图：更新2D视图边透明度
        this.option.series[0].lineStyle.opacity = 1 - val / 100;
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.setOption(this.option, true);
      }
    },
    changeEdgeSlider(val) {
      // 值已经通过计算属性currentEdgeSize的setter自动更新
      if (this.show3DView) {
        // 3D视图：更新3D视图边粗细
        if (this.graph3D) {
          const baseWidth = this.calculateY(this.edgeSize3D);
          const highlightLinks = this._highlightLinks3D || new Set();
          this.graph3D.linkWidth((link) => highlightLinks.has(link) ? baseWidth * 4 : baseWidth);
          this.graph3D.linkWidth(this.graph3D.linkWidth());
        }
      } else {
        // 2D视图：更新2D视图边粗细
        this.option.series[0].lineStyle.width = this.calculateY(val);
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.setOption(this.option, true);
      }
    },

    changeLabelSlider(val) {
      if (this.show3DView) {
        // 3D视图：更新3D标签大小
        // 值已经通过计算属性currentLabelSize的setter自动更新
        if (this.graph3D) {
          // 3D视图的标签大小通过nodeThreeObject中的sprite.textHeight设置
          // 需要重新设置nodeThreeObject来更新标签大小
          // 使用独立的3D节点名称类型
          const getNodeLabel = (node) => {
            const nameType = String(this.nodeNameType3D);
            if (nameType === "1") {
              return node.name || node.id || '';
            } else {
              return node.label || node.name || node.id || '';
            }
          };
          
          // 重新设置nodeThreeObject以更新标签大小
          this.graph3D.nodeThreeObject(node => {
            // 创建文本精灵显示节点标签
            const sprite = new SpriteText(getNodeLabel(node));
            sprite.material.depthWrite = false; // 使文本背景透明
            sprite.color = this.labelColor3D;
            sprite.textHeight = val; // 使用最新的frontSize3D
            sprite.center.y = 0; // 垂直居中
            sprite.center.x = 1.5; // 将文本向右偏移，显示在节点右侧（与2D图的position: 'right'一致）
            return sprite;
          });
          
          // 强制刷新：通过重新调用nodeThreeObject来触发图形更新
          this.graph3D.nodeThreeObject(this.graph3D.nodeThreeObject());
        }
      } else {
        // 2D视图：更新2D标签大小
        this.option.series[0].label.fontSize = val;
        const myChart = this.getOrCreateChart();
        if (!myChart) return;
        myChart.setOption(this.option, true);
      }
    },
    savePics() {
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      let image = myChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      this.images.push(image)
    },
    submitIDs() {
      const names = [];
      for (let i in this.multipleNodeSelection) {
        names.push(this.multipleNodeSelection[i].name);
      }
      for (let i in this.multipleEdgeSelection) {
        names.push(this.multipleEdgeSelection[i].source);
        names.push(this.multipleEdgeSelection[i].target);
      }

      const highlightNodes = [];
      for (let i in this.nodes) {
        if (names.includes(this.nodes[i]['name'])) {
          highlightNodes.push(this.nodes[i]['name']);
        }
      }
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      myChart.dispatchAction({
        type: 'highlight',
        name: highlightNodes
      });
      myChart.setOption(this.option);
    },
    handleNodeSelectionChange(lines) {
      const prevCount = this.multipleNodeSelection.length;
      this.multipleNodeSelection = lines;
      if (this._restoringSelection) return;
      if (this.show3DView && this.graph3D) {
        if (typeof this._clearAllHighlights3D === 'function') this._clearAllHighlights3D();
        if (lines.length === 0) {
          // 没有节点被选中，恢复到初始视角
          this._cameraFocusInProgress = true;
          this.graph3D.zoomToFit(800);
          setTimeout(() => { this._cameraFocusInProgress = false; }, 900);
        } else if (lines.length > prevCount) {
          const lastSelected = lines[lines.length - 1];
          const gData = this.graph3D.graphData();
          if (gData && gData.nodes) {
            const graphNode = gData.nodes.find(n => (n.id !== undefined && n.id === lastSelected.id) || (n.name !== undefined && n.name === lastSelected.name));
            if (graphNode) {
              this._cameraFocusInProgress = true;
              const distance = 80;
              const distRatio = 1 + distance / (Math.hypot(graphNode.x || 0, graphNode.y || 0, graphNode.z || 0) || 1);
              const newPos = graphNode.x != null
                ? { x: graphNode.x * distRatio, y: graphNode.y * distRatio, z: graphNode.z * distRatio }
                : { x: distance, y: 0, z: 0 };
              this.graph3D.cameraPosition(newPos, graphNode, 800);
              setTimeout(() => { this._cameraFocusInProgress = false; }, 900);
            }
          }
        }
        return;
      }
      this.submitIDs();
    },
    handleEdgeSelectionChange(lines) {
      this.multipleEdgeSelection = lines;
      if (this._restoringSelection) return;
      if (this.show3DView && this.graph3D) {
        this._highlightEdgesFromTable();
        return;
      }
      this.submitIDs();
    },
    readCSV(file) {
      const Papa = require('papaparse');
      var request = new XMLHttpRequest();
      request.open("GET", file, false);
      request.send(null);
      var csvData = request.responseText;
      var retList;
      Papa.parse(csvData, {
        complete: function (results) {
          retList = results.data
          // 结果: [ ["col1", "col2", "col3"], ["val1", "val2", "val3"], ["val4", "val5", "val6"] ]
        }
      });
      // console.log(retList)
      var result = [];
      for (var i = 1; i < retList.length; i++) {
        var obj = {};
        for (var j = 0; j < retList[0].length; j++) {
          obj[retList[0][j]] = retList[i][j];
        }
        result.push(obj);
      }
      return result;
    },

    readNodes() {
      this.nodes = []
      this.nodeSource = this.readCSV("EPPD_nodes.csv")
      console.log("nodeSource", this.nodeSource)
      for (var i = 0; i < this.nodeSource.length; i++) {
        var nodeSig = {}
        nodeSig['id'] = this.nodeSource[i]['EXID']
        nodeSig['name'] = this.nodeSource[i]['EXID']
        nodeSig['label'] = this.nodeSource[i]['Preferred name']
        nodeSig['category'] = this.nodeSource[i]['Group name']
        this.nodes.push(nodeSig)
      }
    },
    readLinks() {
      this.edges = []
      this.edgeSource = this.readCSV("EPPD_edges.csv")
      console.log("edgeSource", this.edgeSource)
      for (var i = 0; i < this.edgeSource.length; i++) {
        var edgeSig = {}
        edgeSig['source'] = this.edgeSource[i]['Source']
        edgeSig['target'] = this.edgeSource[i]['Target']
        this.edges.push(edgeSig)
      }
    },
    setLegend() {
      console.log('🏷️ [setLegend] 开始设置图例...');
      console.log('📊 [setLegend] 输入节点数量:', this.nodes.length);
      
      //先去重
      this.legend = []
      this.categories = []

      var uniqueNames = [];
      this.nodes.forEach(function (item) {
        const category = item.category || 'Unknown';
        if (uniqueNames.indexOf(category) === -1) {
          uniqueNames.push(category);
        }
      });

      console.log('🔍 [setLegend] 去重后的类别:', uniqueNames);

      // 使用将筛选后的名称放入新数组
      var namesArray = uniqueNames.map(function (item) {
        return {"category": item};
      });
      
      for (var i = 0; i < namesArray.length; i++) {
        var nodeSig = {}
        nodeSig['name'] = namesArray[i]['category']
        // console.log("test:",namesArray[i]['category'].split(" ")[1])
        if (namesArray[i]['category'].split(" ")[1] == ("(prot)") || namesArray[i]['category'].split(" ")[1] == ("（prot）")) {
          nodeSig['icon'] = "triangle"
        } else if (namesArray[i]['category'].split(" ")[1] == ("(met)") || namesArray[i]['category'].split(" ")[1] == ("（met）")) {
          nodeSig['icon'] = "diamond"
        } else {
          nodeSig['icon'] = this.legends_set[namesArray[i]['category']] || "circle"
        }
        this.legend.push(nodeSig)

        var category = {}
        category['name'] = namesArray[i]['category']
        if (namesArray[i]['category'].split(" ")[1] == ("(prot)") || namesArray[i]['category'].split(" ")[1] == ("（prot）")) {
          category['symbol'] = "triangle"
        } else if (namesArray[i]['category'].split(" ")[1] == ("(met)") || namesArray[i]['category'].split(" ")[1] == ("（met）")) {
          category['symbol'] = "diamond"
        } else {
          category['symbol'] = this.legends_set[namesArray[i]['category']] || "circle"
        }
        this.categories.push(category)
      }
      
      console.log('✅ [setLegend] 图例设置完成:', {
        legendCount: this.legend.length,
        categoriesCount: this.categories.length,
        legend: this.legend,
        categories: this.categories
      });
    },
    readSymbolSize() {
      console.log('📏 [readSymbolSize] 开始计算节点符号大小...');
      console.log('📊 [readSymbolSize] 当前数据状态:', {
        nodesLength: this.nodes.length,
        edgesLength: this.edges.length,
        nodeScaleFactor: this.nodeScaleFactor,
        nodeType: this.nodeType
      });
      
      // 创建节点数据的副本，避免直接修改响应式数据
      const nodesCopy = JSON.parse(JSON.stringify(this.nodes));
      
      for (var i = 0; i < nodesCopy.length; i++) {
        var size = 1;
        for (var j = 0; j < this.edges.length; j++) {
          // 添加防护性检查避免 undefined 错误
          const edgeSource = this.edges[j]['source'];
          const edgeTarget = this.edges[j]['target'];
          const nodeId = nodesCopy[i]['id'];
          
          if (edgeSource && edgeTarget && nodeId && 
              (edgeSource.includes(nodeId) || edgeTarget.includes(nodeId))) {
            size = size + 1;
          }
        }
        nodesCopy[i]['symbolSize'] = size * this.nodeScaleFactor
        nodesCopy[i]['value'] = size
        if (this.nodeType == "1") {
          delete nodesCopy[i].symbolSize
          delete nodesCopy[i].value
        }
      }
      
      // 使用Vue.set或直接赋值来更新响应式数据
      this.nodes = nodesCopy;
      
      console.log('✅ [readSymbolSize] 节点符号大小计算完成');
    },
    readSymbolSize3D() {
      // 创建节点数据的副本，避免直接修改响应式数据
      const nodesCopy = JSON.parse(JSON.stringify(this.nodes));
      
      // 先计算所有节点的边数，找出最大值和最小值
      const nodeEdgeCounts = {};
      let maxEdges = 1;
      let minEdges = Infinity;
      
      for (var i = 0; i < nodesCopy.length; i++) {
        var size = 1;
        for (var j = 0; j < this.edges.length; j++) {
          // 添加防护性检查避免 undefined 错误
          const edgeSource = this.edges[j]['source'];
          const edgeTarget = this.edges[j]['target'];
          const nodeId = nodesCopy[i]['id'];
          
          if (edgeSource && edgeTarget && nodeId && 
              (edgeSource.includes(nodeId) || edgeTarget.includes(nodeId))) {
            size = size + 1;
          }
        }
        nodeEdgeCounts[nodesCopy[i]['id']] = size;
        maxEdges = Math.max(maxEdges, size);
        minEdges = Math.min(minEdges, size);
      }
      
      // 计算节点大小，确保有合理的范围
      // 最小节点大小对应最小边数，最大节点大小对应最大边数
      const minNodeSize = 4; // 最小节点大小（3D相对大小），保证小节点可见
      // 最大节点大小基于当前滑块值，但使用更大的范围来显示差异
      // 使用更大的倍数来放大节点大小差异，让边数多的节点更明显
      const baseMaxSize = (this.nodevSize3D / 10) * 6;
      // 根据边数范围动态调整最大节点大小，确保有足够的视觉差异
      // 如果边数范围很大（maxEdges > 20），使用更大的最大节点大小
      // 使用平方根或对数缩放来放大差异，让大节点更明显
      const edgeRange = maxEdges - minEdges;
      let sizeMultiplier = 1.0;
      if (edgeRange > 50) {
        sizeMultiplier = 20.0; // 边数范围很大时，使用20倍，让差异更明显
      } else if (edgeRange > 20) {
        sizeMultiplier = 10.0; // 边数范围较大时，使用10倍
      } else if (edgeRange > 10) {
        sizeMultiplier = 5.0; // 边数范围中等时，使用5倍
      } else {
        sizeMultiplier = 2.5; // 边数范围较小时，使用2.5倍
      }
      const maxNodeSize = Math.max(baseMaxSize * sizeMultiplier, 40); // 确保最大节点大小至少为40，让差异更明显
      
      for (var i = 0; i < nodesCopy.length; i++) {
        const edgeCount = nodeEdgeCounts[nodesCopy[i]['id']] || 1;
        
        if (maxEdges === minEdges) {
          // 如果所有节点边数相同，使用中等大小
          nodesCopy[i]['value'] = (minNodeSize + maxNodeSize) / 2;
        } else {
          // 根据边数在最小和最大之间线性插值
          const ratio = (edgeCount - minEdges) / (maxEdges - minEdges);
          nodesCopy[i]['value'] = minNodeSize + (maxNodeSize - minNodeSize) * ratio;
        }
        
        if (this.nodeType3D == "1") {
          delete nodesCopy[i].value;
        }
      }
      
      // 使用Vue.set或直接赋值来更新响应式数据
      this.nodes = nodesCopy;
    },
    validateData() {
      console.log('🔍 [validateData] 开始验证数据...');
      
      // 检查节点数据
      if (!this.nodes || this.nodes.length === 0) {
        console.error('❌ [validateData] 节点数据为空');
        return false;
      }
      
      // 检查边数据
      if (!this.edges || this.edges.length === 0) {
        console.warn('⚠️ [validateData] 边数据为空，将渲染孤立节点');
      }
      
      // 验证节点数据格式
      const invalidNodes = this.nodes.filter(node => !node.id || !node.name);
      if (invalidNodes.length > 0) {
        console.error('❌ [validateData] 发现无效节点:', invalidNodes);
        return false;
      }
      
      // 收集所有有效的节点ID
      const nodeIds = new Set(this.nodes.map(node => node.id).filter(id => id));
      console.log('📊 [validateData] 有效节点ID数量:', nodeIds.size);
      
      // 检查是否有重复的节点ID
      const allNodeIds = this.nodes.map(node => node.id).filter(id => id);
      const duplicateIds = allNodeIds.filter((id, index) => allNodeIds.indexOf(id) !== index);
      if (duplicateIds.length > 0) {
        console.error('❌ [validateData] 发现重复的节点ID:', [...new Set(duplicateIds)]);
        return false;
      }
      
      // 验证边数据并清理无效边
      const validEdges = [];
      const invalidEdges = [];
      
      this.edges.forEach((edge, index) => {
        if (!edge.source || !edge.target) {
          invalidEdges.push({index, edge, reason: 'missing source or target'});
          return;
        }
        
        if (!nodeIds.has(edge.source)) {
          invalidEdges.push({index, edge, reason: `source node '${edge.source}' not found`});
          return;
        }
        
        if (!nodeIds.has(edge.target)) {
          invalidEdges.push({index, edge, reason: `target node '${edge.target}' not found`});
          return;
        }
        
        validEdges.push(edge);
      });
      
      // 更新边数据为有效边
      this.edges = validEdges;
      
      console.log('📊 [validateData] 数据验证结果:', {
        totalNodes: this.nodes.length,
        validNodes: nodeIds.size,
        totalEdges: this.edges.length + invalidEdges.length,
        validEdges: validEdges.length,
        invalidEdges: invalidEdges.length,
        categories: this.categories.length
      });
      
      if (invalidEdges.length > 0) {
        console.warn('⚠️ [validateData] 发现无效边:', invalidEdges.slice(0, 5)); // 只显示前5个
      }
      
      return true;
    },
    // 辅助方法：获取或创建 ECharts 实例，避免重复初始化
    getOrCreateChart() {
      const mainview = document.getElementById('mainview');
      if (!mainview) {
        return null;
      }
      
      // 尝试获取现有实例
      let myChart = this.$echarts.getInstanceByDom(mainview);
      if (!myChart) {
        // 如果不存在，创建新实例
        myChart = this.$echarts.init(mainview, null, {renderer: 'svg'});
      }
      return myChart;
    },
    // 销毁 2D ECharts 实例
    destroy2DView() {
      console.log('🧹 [destroy2DView] 开始销毁2D视图...');
      const mainview = document.getElementById('mainview');
      if (!mainview) {
        console.warn('⚠️ [destroy2DView] 找不到mainview容器');
        return;
      }
      
      // 获取 ECharts 实例
      const myChart = this.$echarts.getInstanceByDom(mainview);
      if (myChart) {
        try {
          // 销毁 ECharts 实例
          myChart.dispose();
          console.log('✅ [destroy2DView] 2D视图已销毁');
        } catch (error) {
          console.warn('⚠️ [destroy2DView] 销毁2D视图时出错:', error);
        }
      } else {
        console.log('ℹ️ [destroy2DView] 2D视图实例不存在，无需销毁');
      }
    },
    // 销毁 3D 图形实例
    destroy3DView() {
      console.log('🧹 [destroy3DView] 开始销毁3D视图...');
      if (!this.graph3D) {
        console.log('ℹ️ [destroy3DView] 3D视图实例不存在，无需销毁');
        return;
      }
      
      try {
        // 清理防抖定时器
        if (this._updateHighlightTimer) {
          clearTimeout(this._updateHighlightTimer);
          this._updateHighlightTimer = null;
        }
        
        // 清理 WebGL 上下文
        if (this.graph3D.renderer && this.graph3D.renderer.getContext) {
          const gl = this.graph3D.renderer.getContext();
          if (gl) {
            const loseContext = gl.getExtension('WEBGL_lose_context');
            if (loseContext) {
              loseContext.loseContext();
            }
          }
        }
        
        // 销毁 3D 图形实例
        this.graph3D._destructor();
        this.graph3D = null;
        console.log('✅ [destroy3DView] 3D视图已销毁');
      } catch (error) {
        console.warn('⚠️ [destroy3DView] 销毁3D视图时出错:', error);
        // 即使出错也要清空引用
        this.graph3D = null;
      }
    },
    restoreFigure() {
      console.log('🎯 [restoreFigure] 开始恢复图形...');
      
      // 验证数据完整性
      if (!this.validateData()) {
        console.error('❌ [restoreFigure] 数据验证失败，停止渲染');
        return;
      }
      
      this.readSymbolSize()
      this.option = {
        // backgroundColor: '#D2D2D2',
        title: {
          // text: 'Node Moving',
          // subtext: 'Default layout',
          top: 'bottom',
          left: 'center'
        },
        color: this.colorList,
        tooltip: {
          formatter: (params) => {
            if (params.dataType === 'node') {
              // 节点悬浮显示: EXID 和 Degree (不换行)
              const name = params.data.name || '';
              const degree = params.data.Degree || 0;
              return `${name} ${degree}`;
            } else if (params.dataType === 'edge') {
              // 边的悬浮显示
              return `${params.data.source} → ${params.data.target}`;
            }
            return params.name;
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: false,
              name: "test",
              title: 'Save As Image'
            },
            restore: {
              show: false,
            },
          },
          top: 35
        },
        legend: [{
          show: true,
          data: this.legend,
          orient: 'vertical',
          left: 'left'
          // animation :true
        }],
        series: [{
          emphasis: {
            disabled: false,
            focus: 'self',
            scale: 3,
          },
          // silent: true,
          // name: 'demo',
          name: "",
          type: 'graph',
          layout: 'force',
          draggable: true,
          data: this.nodes,
          links: this.edges,
          categories: this.categories,
          //categories: graph.categories,
          roam: true,
          label: {
            show: true,
            position: 'right',
            fontSize: this.frontSize,
            formatter: ((params) => {
              if (this.nodeNameType == "1") {
                return `${params.data.name}`
              } else {
                return `${params.data.label}`
              }
            })

          },
          force: {
            repulsion: 100,
            layoutAnimation: false,
          },
          lineStyle: {
            color: this.linecolor,
            width: this.calculateY(this.edgeSize),
          },
          // 根据nodeType设置节点大小
          symbolSize: this.nodeType == 1 ? this.nodevSize : undefined, // nodeType为1时使用固定大小
        }],
      }
      
      console.log('📊 [restoreFigure] ECharts配置准备完成:', {
        nodes: this.nodes.length,
        edges: this.edges.length,
        categories: this.categories.length,
        sampleNode: this.nodes[0] || {},
        sampleEdge: this.edges[0] || {}
      });
      
      let myChart = null;
      try {
        const mainview = document.getElementById('mainview');
        if (!mainview) {
          console.error('❌ [restoreFigure] 找不到mainview容器');
          return;
        }

        // 检查是否已存在图表实例
        myChart = this.$echarts.getInstanceByDom(mainview);
        if (!myChart) {
          // 如果不存在，创建新实例
          myChart = this.$echarts.init(mainview, null, {renderer: 'svg'})
          console.log('📈 [restoreFigure] ECharts新实例初始化完成');
        } else {
          console.log('📈 [restoreFigure] 使用已存在的ECharts实例');
        }
        
      myChart.setOption(this.option)
        console.log('✅ [restoreFigure] ECharts配置设置完成');
      } catch (error) {
        console.error('💥 [restoreFigure] ECharts设置出错:', {
          error: error.message,
          stack: error.stack,
          optionKeys: Object.keys(this.option),
          seriesData: this.option.series[0]
        });
        return;
      }

      if (myChart) {
        try {
          console.log('🎯 [restoreFigure] 开始获取模型数据和更新布局...');
      this.model = myChart.getModel().getSeriesByIndex(0).getData()._itemLayouts;
      this.modelName = myChart.getModel().getSeriesByIndex(0).getData()._nameList
          console.log('📊 [restoreFigure] 模型数据获取完成:', {
            layoutsCount: this.model ? this.model.length : 0,
            namesCount: this.modelName ? this.modelName.length : 0
          });
          
          // 创建节点数据的副本，避免直接修改响应式数据
          const nodesWithPosition = JSON.parse(JSON.stringify(this.nodes));
          for (let i in nodesWithPosition) {
            nodesWithPosition[i]['x'] = this.model[i][0]
            nodesWithPosition[i]['y'] = this.model[i][1]
          }
          this.option.series[0].data = nodesWithPosition;
      this.option.series[0].layout = 'none';
      
      // 节点大小：根据nodeType设置
      if (this.nodeType == 1) {
        this.option.series[0].symbolSize = this.nodevSize;
      }

      myChart.setOption(this.option, true)
          console.log('✅ [restoreFigure] 图形恢复完成');
        } catch (layoutError) {
          console.error('💥 [restoreFigure] 布局更新出错:', {
            error: layoutError.message,
            stack: layoutError.stack,
            nodesCount: this.nodes.length,
            modelExists: !!this.model
          });
        }
      }
    },
  calculateY(x) {
    if (x >= 0 && x <= 10) {
      return (1 / 100) * Math.pow(x, 2);
    } else if (x > 10 && x <= 20) {
      return (2 / 5) * x - 3;
    } else {
      return 0; // 超出定义域的值返回 null
    }
},
    configColorList() {
      const previousColorsByCategory = {}
      if (this.colorsInitialized) {
        this.categories.forEach((category, index) => {
          if (category && category.name && this.colorList[index]) {
            previousColorsByCategory[category.name] = this.colorList[index]
          }
        })
      }

      const nextColorList = []
      console.log("this.legend", this.legend)
      const overrides = this.categoryColorOverrides || {}
      for (var i = 0; i < this.legend.length; i++) {
        var legendName = this.legend[i].name
        if (Object.prototype.hasOwnProperty.call(previousColorsByCategory, legendName)) {
          nextColorList.push(previousColorsByCategory[legendName])
          continue
        }
        // 外部传入的类别颜色覆盖优先级最高（按类别名精确匹配）
        if (Object.prototype.hasOwnProperty.call(overrides, legendName)) {
          nextColorList.push(overrides[legendName])
          continue
        }
        var type_list = Object.keys(this.proteinColorList)
        var type = legendName.toLowerCase().split(" ")[0]
        if (type_list.indexOf(type) !== -1) {
          console.log("in")
          nextColorList.push(this.proteinColorList[type])
        } else if (legendName.toLowerCase().startsWith('exposure')) {
          nextColorList.push("#0700d3")
        } else if (legendName.toLowerCase().startsWith('disease')) {
          nextColorList.push("#d30004")
        } else {
          nextColorList.push("#0bedd3")
        }
      }
      this.colorList = nextColorList
      this.colorList3D = nextColorList.map(color => this.normalizeGraphColor(color))
      this.colorList3DBase = [...this.colorList3D]
      this.colorsInitialized = true
    },
    showFigure() {
      console.log('📈 [showFigure] 开始显示图表...');
      console.log('📊 [showFigure] 当前数据状态:', {
        nodesCount: this.nodes.length,
        edgesCount: this.edges.length,
        categoriesCount: this.categories.length,
        legendCount: this.legend.length
      });
      
      const myChart = this.getOrCreateChart();
      if (!myChart) {
        console.error('❌ [showFigure] 无法创建或获取ECharts实例');
        return;
      }
      console.log('📊 [showFigure] ECharts实例已初始化');
      
      // this.readNodes()
      // this.readLinks()
      // this.setLegend()

      console.log('🎨 [showFigure] 开始配置颜色列表...');
      this.configColorList()
      console.log('🎨 [showFigure] 颜色配置完成:', this.colorList);
      
      this.nodetableData = this.nodes
      this.edgetableData = this.edges
      console.log('📋 [showFigure] 表格数据已设置');
      // 监听 contextmenu 事件
      myChart.on('contextmenu', function (params) {
        // 只有在节点上右击时才执行
        if (params.data) {
          // 阻止默认的右键菜单
          event.preventDefault();
          // 获取节点数据
          var nodeData = params.data;
          var input = document.createElement('input');
          input.value = nodeData['name'];
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          ElMessage({
            message: 'copy success!' + input.value,
            type: 'success',
          })
        }
      });
      myChart.on('mouseover', params => {
        // console.log(params)
      });

      myChart.on('mouseout', params => {
        // console.log(params)
      });
      myChart.on('click', params => {
        // 点击节点
        if (params.dataType == "node") {
          this.$message({
            message: "You have clicked node ：" + params.data.name + "\n" + "Its detailed label is:" + params.data.label,
            type: 'success'
          })
        }
        if (params.dataType == "edge") {
          this.$message({
            message: "You have clicked edge : " + params.name + "\n" + "Its detailed interaction is:" + params.data.interaction,
            type: 'success'
          })
        }
      });
      console.log('🎯 [showFigure] 开始执行restoreFigure...');
      this.restoreFigure()
      console.log('✅ [showFigure] 图表显示完成！');
    },
    handleNodeChange(val) {
      if (this.$refs.singleTable1) this.$refs.singleTable1.toggleRowSelection(val, true);
      if (this.show3DView && this.graph3D) {
        // 3D 视图：仅将相机对准该节点并放大，不高亮边
        const gData = this.graph3D.graphData();
        if (!gData || !gData.nodes) return;
        const graphNode = gData.nodes.find(n => (n.id !== undefined && n.id === val.id) || (n.name !== undefined && n.name === val.name));
        if (graphNode) {
          // 清空全部高亮（包括闭包内的 hoverNode），让边恢复默认宽度和粒子
          if (typeof this._clearAllHighlights3D === 'function') this._clearAllHighlights3D();
          // 在相机动画期间阻止 hover 重新设高亮
          this._cameraFocusInProgress = true;
          const distance = 80;
          const distRatio = 1 + distance / (Math.hypot(graphNode.x || 0, graphNode.y || 0, graphNode.z || 0) || 1);
          const newPos = graphNode.x != null
            ? { x: graphNode.x * distRatio, y: graphNode.y * distRatio, z: graphNode.z * distRatio }
            : { x: distance, y: 0, z: 0 };
          this.graph3D.cameraPosition(newPos, graphNode, 800);
          setTimeout(() => { this._cameraFocusInProgress = false; }, 900);
        }
        return;
      }
      const myChart = this.getOrCreateChart();
      if (!myChart) return;
      this.model = myChart.getModel().getSeriesByIndex(0).getData()._itemLayouts;
      this.nowCenter = this.model[this.nodetableData.indexOf(val) + 1]
      this.option.series[0].center = this.nowCenter;
      this.option.series[0].zoom = 3;
    },
    _restoreTableSelectionAndHighlight() {
      const restoreNodeNames = this._pendingRestoreNodeNames || [];
      const restoreEdgeKeys = this._pendingRestoreEdgeKeys || [];
      this._pendingRestoreNodeNames = [];
      this._pendingRestoreEdgeKeys = [];

      console.log('🔄 [_restoreTableSelection] 开始恢复:', {
        nodeNames: restoreNodeNames,
        edgeKeys: restoreEdgeKeys,
        show3DView: this.show3DView,
        hasGraph3D: !!this.graph3D,
        hasHighlightNodes: !!this._highlightNodes3D,
        hasHighlightLinks: !!this._highlightLinks3D,
        hasClearFn: typeof this._clearAllHighlights3D === 'function',
        hasUpdateFn: typeof this._update3DHighlight === 'function',
        nodetableDataLen: this.nodetableData?.length,
        edgetableDataLen: this.edgetableData?.length,
        singleTable1Exists: !!this.$refs.singleTable1,
        singleTable2Exists: !!this.$refs.singleTable2,
      });

      this._restoringSelection = true;
      this.$nextTick(() => {
        let nodesRestored = 0;
        let edgesRestored = 0;
        if (this.$refs.singleTable1) {
          this.$refs.singleTable1.clearSelection();
          if (restoreNodeNames.length > 0) {
            const nameSet = new Set(restoreNodeNames);
            this.nodetableData.forEach(row => {
              if (nameSet.has(row.name) || nameSet.has(row.id)) {
                this.$refs.singleTable1.toggleRowSelection(row, true);
                nodesRestored++;
              }
            });
          }
        }
        if (this.$refs.singleTable2) {
          this.$refs.singleTable2.clearSelection();
          if (restoreEdgeKeys.length > 0) {
            const keySet = new Set(restoreEdgeKeys);
            this.edgetableData.forEach(row => {
              if (keySet.has(row.source + '|||' + row.target)) {
                this.$refs.singleTable2.toggleRowSelection(row, true);
                edgesRestored++;
              }
            });
          }
        }
        this._restoringSelection = false;

        console.log('✅ [_restoreTableSelection] 恢复完成:', {
          nodesRestored,
          edgesRestored,
          multipleNodeSelectionLen: this.multipleNodeSelection.length,
          multipleEdgeSelectionLen: this.multipleEdgeSelection.length,
          show3DView: this.show3DView,
          hasGraph3D: !!this.graph3D,
        });

        // 3D 视图下，表格恢复完成后应用高亮/聚焦
        if (this.show3DView && this.graph3D) {
          this.$nextTick(() => {
            if (this.multipleEdgeSelection.length > 0) {
              console.log('🎯 [_restoreTableSelection] 恢复边高亮');
              this._highlightEdgesFromTable();
            }
            if (this.multipleNodeSelection.length > 0) {
              console.log('🎯 [_restoreTableSelection] 恢复节点聚焦');
              const lastNode = this.multipleNodeSelection[this.multipleNodeSelection.length - 1];
              // 等待物理模拟基本稳定后再聚焦相机
              setTimeout(() => {
                if (!this.graph3D) return;
                const gData = this.graph3D.graphData();
                if (gData && gData.nodes) {
                  const graphNode = gData.nodes.find(n =>
                    (n.id !== undefined && n.id === lastNode.id) ||
                    (n.name !== undefined && n.name === lastNode.name)
                  );
                  if (graphNode) {
                    console.log('📍 [_restoreTableSelection] 聚焦节点:', graphNode.id, { x: graphNode.x, y: graphNode.y, z: graphNode.z });
                    const distance = 80;
                    const distRatio = 1 + distance / (Math.hypot(graphNode.x || 0, graphNode.y || 0, graphNode.z || 0) || 1);
                    const newPos = graphNode.x != null
                      ? { x: graphNode.x * distRatio, y: graphNode.y * distRatio, z: graphNode.z * distRatio }
                      : { x: distance, y: 0, z: 0 };
                    this.graph3D.cameraPosition(newPos, graphNode, 800);
                  }
                }
              }, 2000);
            }
          });
        }
      });
    },
    _highlightEdgesFromTable() {
      console.log('📌 [_highlightEdgesFromTable] 开始:', {
        hasGraph3D: !!this.graph3D,
        hasHighlightNodes: !!this._highlightNodes3D,
        hasHighlightLinks: !!this._highlightLinks3D,
        multipleEdgeSelectionLen: this.multipleEdgeSelection.length,
      });
      if (!this.graph3D || !this._highlightNodes3D || !this._highlightLinks3D) {
        console.warn('⚠️ [_highlightEdgesFromTable] 缺少必要引用，退出');
        return;
      }
      const gData = this.graph3D.graphData();
      if (!gData || !gData.links) {
        console.warn('⚠️ [_highlightEdgesFromTable] graphData 无效，退出');
        return;
      }

      // 收集所有选中边的 source-target 对
      const selectedPairs = new Set();
      this.multipleEdgeSelection.forEach(e => {
        selectedPairs.add(String(e.source) + '|||' + String(e.target));
      });
      // 也包括当前单击选中的行（currentRow in singleTable2）
      if (this.$refs.singleTable2) {
        const currentRow = this.$refs.singleTable2.store?.states?.currentRow?.value;
        if (currentRow) {
          selectedPairs.add(String(currentRow.source) + '|||' + String(currentRow.target));
        }
      }

      console.log('📌 [_highlightEdgesFromTable] selectedPairs:', [...selectedPairs]);
      console.log('📌 [_highlightEdgesFromTable] graphData links 数:', gData.links.length);
      if (gData.links.length > 0) {
        const sampleLink = gData.links[0];
        console.log('📌 [_highlightEdgesFromTable] 示例 link source:', {
          type: typeof sampleLink.source,
          isObject: typeof sampleLink.source === 'object',
          id: sampleLink.source?.id,
          name: sampleLink.source?.name,
          raw: typeof sampleLink.source === 'string' ? sampleLink.source : '(object)',
        });
      }

      if (typeof this._clearAllHighlights3D === 'function') this._clearAllHighlights3D();

      let matchedCount = 0;
      gData.links.forEach(link => {
        const src = typeof link.source === 'object' ? (link.source.id ?? link.source.name) : link.source;
        const tgt = typeof link.target === 'object' ? (link.target.id ?? link.target.name) : link.target;
        if (selectedPairs.has(String(src) + '|||' + String(tgt))) {
          this._highlightLinks3D.add(link);
          this._highlightNodes3D.add(link.source);
          this._highlightNodes3D.add(link.target);
          matchedCount++;
        }
      });

      console.log('✅ [_highlightEdgesFromTable] 匹配结果:', {
        matchedCount,
        highlightLinksSize: this._highlightLinks3D.size,
        highlightNodesSize: this._highlightNodes3D.size,
      });

      if (typeof this._update3DHighlight === 'function') {
        this._update3DHighlight();
        console.log('✅ [_highlightEdgesFromTable] _update3DHighlight 已调用');
      }
    },
    handleEdgeChange(val) {
      if (this.$refs.singleTable2) this.$refs.singleTable2.toggleRowSelection(val, true);
      if (this.show3DView && this.graph3D) {
        this._highlightEdgesFromTable();
      }
    },
    handleResize() {
      // 更新窗口宽度
      this.windowWidth = window.innerWidth;
      
      // 清除之前的防抖定时器
      if (this._resizeTimer) {
        clearTimeout(this._resizeTimer);
      }
      
      // 使用防抖机制，避免频繁触发（150ms延迟）
      this._resizeTimer = setTimeout(() => {
        // 调用 resizeGraph 方法，根据当前视图类型调整对应的图表
        this.resizeGraph();
        
        // 清除定时器引用
        this._resizeTimer = null;
      }, 150); // 150ms防抖延迟，平衡响应速度和性能
    },
    toggle3DView() {
      const was3DView = this.show3DView;

      // 保存当前视图的选中状态（存储节点 name / 边 source+target 作为标识）
      if (was3DView) {
        this._selectedNodeNames3D = this.multipleNodeSelection.map(n => n.name || n.id);
        this._selectedEdgeKeys3D = this.multipleEdgeSelection.map(e => e.source + '|||' + e.target);
      } else {
        this._selectedNodeNames2D = this.multipleNodeSelection.map(n => n.name || n.id);
        this._selectedEdgeKeys2D = this.multipleEdgeSelection.map(e => e.source + '|||' + e.target);
      }

      this.show3DView = !this.show3DView;

      // 取出目标视图要恢复的标识
      const restoreNodeNames = this.show3DView
        ? (this._selectedNodeNames3D || [])
        : (this._selectedNodeNames2D || []);
      const restoreEdgeKeys = this.show3DView
        ? (this._selectedEdgeKeys3D || [])
        : (this._selectedEdgeKeys2D || []);

      // 先清空表格勾选 + 数据数组
      this.multipleNodeSelection = [];
      this.multipleEdgeSelection = [];
      // 保存待恢复的标识，供 3D 初始化完成后使用
      this._pendingRestoreNodeNames = restoreNodeNames;
      this._pendingRestoreEdgeKeys = restoreEdgeKeys;

      // 如果切换到2D视图
      if (!this.show3DView) {
        // 退出全屏（如果正在全屏）
        if (this.isFullscreen) {
          this.isFullscreen = false;
          this.exitFullscreen();
        }
        
        // 销毁3D实例
        if (was3DView) {
          this.destroy3DView();
        }
        
        // 如果数据已加载，初始化2D视图
        if (!this.dataLoading && this.nodes.length > 0) {
          this.$nextTick(() => {
            // 等待DOM更新，确保2D容器已显示
            setTimeout(() => {
              const mainview = document.getElementById('mainview');
              if (mainview) {
                // 检查图表实例是否存在
                let myChart = this.$echarts.getInstanceByDom(mainview);
      if (myChart) {
                  // 如果图表实例已存在，先调整大小
        myChart.resize();
                  // 重新设置配置，确保图表正确显示
                  this.restoreFigure();
                  console.log('✅ [toggle3DView] 2D图表已重新配置和调整大小');
                } else {
                  // 如果图表实例不存在，重新渲染
                  console.log('🔄 [toggle3DView] 2D图表实例不存在，重新渲染...');
                  this.showFigure();
                }
                // 2D 初始化完成后恢复表格勾选
                this._restoreTableSelectionAndHighlight();
              }
            }, 100);
          });
        }
      } 
      // 如果切换到3D视图
      else {
        // 销毁2D实例
        if (!was3DView) {
          this.destroy2DView();
        }
        
        // 如果数据已加载，初始化3D视图
        if (!this.dataLoading && this.nodes.length > 0) {
          this.$nextTick(async () => {
            await this.showFigure3D();
            // 3D 初始化完成后，恢复表格勾选状态并应用高亮
            this._restoreTableSelectionAndHighlight();
          });
        }
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      if (this.isFullscreen) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    },
    enterFullscreen() {
      // 根据当前视图选择容器
      const container = this.show3DView 
        ? document.getElementById('mainview3d')
        : document.getElementById('mainview');
      
      if (!container) {
        console.error('❌ [enterFullscreen] 找不到容器元素');
        return;
      }

      // 如果是2D视图，设置ECharts背景色为白色
      if (!this.show3DView) {
        const mainview = document.getElementById('mainview');
        if (mainview) {
          let myChart = this.$echarts.getInstanceByDom(mainview);
          if (myChart) {
            // 保存原始背景色（如果存在）
            if (!this._originalBackgroundColor) {
              this._originalBackgroundColor = this.option.backgroundColor || 'transparent';
            }
            // 设置白色背景
            this.option.backgroundColor = '#fff';
            myChart.setOption(this.option, false);
          }
        }
      }

      // 使用 Fullscreen API
      if (container.requestFullscreen) {
        container.requestFullscreen().then(() => {
          console.log('✅ [enterFullscreen] 已进入全屏模式');
          this.$nextTick(() => {
            this.resizeGraph();
          });
        }).catch(err => {
          console.error('❌ [enterFullscreen] 进入全屏失败:', err);
          // 如果 Fullscreen API 失败，使用 CSS 方式
          this.enterFullscreenCSS();
        });
      } else if (container.webkitRequestFullscreen) {
        // Safari 支持
        container.webkitRequestFullscreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else if (container.mozRequestFullScreen) {
        // Firefox 支持
        container.mozRequestFullScreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else if (container.msRequestFullscreen) {
        // IE/Edge 支持
        container.msRequestFullscreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else {
        // 降级到 CSS 方式
        this.enterFullscreenCSS();
      }

      // 监听全屏退出事件
      this.addFullscreenListeners();
    },
    exitFullscreen() {
      // 如果是2D视图，恢复原始背景色
      if (!this.show3DView && this._originalBackgroundColor !== undefined) {
        const mainview = document.getElementById('mainview');
        if (mainview) {
          let myChart = this.$echarts.getInstanceByDom(mainview);
          if (myChart) {
            // 恢复原始背景色
            this.option.backgroundColor = this._originalBackgroundColor;
            myChart.setOption(this.option, false);
            // 清除保存的背景色
            this._originalBackgroundColor = undefined;
          }
        }
      }

      // 使用 Fullscreen API 退出
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          console.log('✅ [exitFullscreen] 已退出全屏模式');
          this.$nextTick(() => {
            this.resizeGraph();
          });
        }).catch(err => {
          console.error('❌ [exitFullscreen] 退出全屏失败:', err);
          this.exitFullscreenCSS();
        });
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        this.$nextTick(() => {
          this.resizeGraph();
        });
      } else {
        this.exitFullscreenCSS();
      }

      // 移除全屏监听器
      this.removeFullscreenListeners();
    },
    enterFullscreenCSS() {
      // 根据当前视图选择容器
      const container = this.show3DView 
        ? document.getElementById('mainview3d')
        : document.getElementById('mainview');
      
      if (!container) return;

      // 使用 CSS 固定定位铺满全屏
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.width = '100vw';
      container.style.height = '100vh';
      container.style.zIndex = '9999';
      container.style.backgroundColor = '#fff';

      // 如果是2D视图，设置ECharts背景色为白色
      if (!this.show3DView) {
        const mainview = document.getElementById('mainview');
        if (mainview) {
          let myChart = this.$echarts.getInstanceByDom(mainview);
          if (myChart) {
            // 保存原始背景色（如果存在）
            if (!this._originalBackgroundColor) {
              this._originalBackgroundColor = this.option.backgroundColor || 'transparent';
            }
            // 设置白色背景
            this.option.backgroundColor = '#fff';
            myChart.setOption(this.option, false);
          }
        }
      }

      console.log('✅ [enterFullscreenCSS] 使用CSS方式进入全屏');
      this.$nextTick(() => {
        this.resizeGraph();
      });
    },
    exitFullscreenCSS() {
      // 根据当前视图选择容器
      const container = this.show3DView 
        ? document.getElementById('mainview3d')
        : document.getElementById('mainview');
      
      if (!container) return;

      // 恢复原始样式
      container.style.position = 'relative';
      container.style.top = '';
      container.style.left = '';
      container.style.width = '';
      container.style.height = '95vh';
      container.style.zIndex = '';

      // 如果是2D视图，恢复原始背景色
      if (!this.show3DView && this._originalBackgroundColor !== undefined) {
        const mainview = document.getElementById('mainview');
        if (mainview) {
          let myChart = this.$echarts.getInstanceByDom(mainview);
          if (myChart) {
            // 恢复原始背景色
            this.option.backgroundColor = this._originalBackgroundColor;
            myChart.setOption(this.option, false);
            // 清除保存的背景色
            this._originalBackgroundColor = undefined;
          }
        }
      }

      console.log('✅ [exitFullscreenCSS] 使用CSS方式退出全屏');
      this.$nextTick(() => {
        this.resizeGraph();
      });
    },
    addFullscreenListeners() {
      // 监听全屏状态变化
      const fullscreenChangeEvents = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ];

      fullscreenChangeEvents.forEach(event => {
        document.addEventListener(event, this.handleFullscreenChange);
      });
    },
    removeFullscreenListeners() {
      const fullscreenChangeEvents = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ];

      fullscreenChangeEvents.forEach(event => {
        document.removeEventListener(event, this.handleFullscreenChange);
      });
    },
    handleFullscreenChange() {
      // 检查是否真的在全屏状态
      const isCurrentlyFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (!isCurrentlyFullscreen && this.isFullscreen) {
        // 用户通过 ESC 键或其他方式退出了全屏
        this.isFullscreen = false;
        
        // 如果是2D视图，恢复原始背景色
        if (!this.show3DView && this._originalBackgroundColor !== undefined) {
          const mainview = document.getElementById('mainview');
          if (mainview) {
            let myChart = this.$echarts.getInstanceByDom(mainview);
            if (myChart) {
              // 恢复原始背景色
              this.option.backgroundColor = this._originalBackgroundColor;
              myChart.setOption(this.option, false);
              // 清除保存的背景色
              this._originalBackgroundColor = undefined;
            }
          }
        }
        
        this.exitFullscreenCSS();
        this.removeFullscreenListeners();
      }
    },
    resizeGraph() {
      // 根据当前视图调整图表尺寸
      if (this.show3DView) {
        // 调整3D图形尺寸
        if (this.graph3D) {
          const mainview3d = document.getElementById('mainview3d');
          if (mainview3d) {
            const width = mainview3d.offsetWidth || window.innerWidth;
            const height = mainview3d.offsetHeight || window.innerHeight;
            this.graph3D.width(width).height(height);
            console.log('✅ [resizeGraph] 3D图形尺寸已调整:', { width, height });
          }
        }
      } else {
        // 调整2D图形尺寸
        const mainview = document.getElementById('mainview');
        if (mainview) {
          let myChart = this.$echarts.getInstanceByDom(mainview);
          if (myChart) {
            myChart.resize();
            console.log('✅ [resizeGraph] 2D图形尺寸已调整');
          }
        }
      }
    },
    // ========== 3d-force-graph 3D 渲染方法 ==========
    async showFigure3D() {
      // 防重复调用检查：如果正在渲染，直接返回
      if (this._isRendering3D) {
        console.log('⏸️ [showFigure3D] 3D图形正在渲染中，跳过重复调用');
        return;
      }

      // 设置渲染标志位
      this._isRendering3D = true;

      // 同步3D颜色列表：如果长度不匹配，从2D颜色列表复制（保持初始颜色一致）
      if (this.colorList3D.length !== this.colorList.length) {
        // 从colorList提取基础颜色（去掉透明度）存储到colorList3D
        // 因为getNodeColor3D会统一应用透明度，所以colorList3D应该存储基础颜色
        this.colorList3D = this.colorList.map(color => {
          // 如果颜色是rgba格式，提取rgb部分作为基础颜色
          if (color.startsWith('rgba')) {
            const rgb = color.match(/\d+/g);
            return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
          }
          // 如果颜色是hex格式，提取rgb部分（去掉alpha通道）
          if (color.length > 7) {
            return color.substring(0, 7);
          }
          return color;
        });
      }

      // 初始化3D原始颜色列表（不带透明度），用于兼容
      if (!this.colorList3DBase || this.colorList3DBase.length !== this.colorList3D.length) {
        this.colorList3DBase = [...this.colorList3D];
      }

      try {
        console.log('🎨 [showFigure3D] 开始渲染3D图形...');
        console.log('📊 [showFigure3D] 输入数据状态:', {
          nodesCount: this.nodes.length,
          edgesCount: this.edges.length
        });

        // 验证数据
        if (!this.nodes || this.nodes.length === 0) {
          console.error('❌ [showFigure3D] 节点数据为空，无法渲染3D图形');
          return;
        }

        // 获取容器元素
        const container = document.getElementById('mainview3d');
        if (!container) {
          console.error('❌ [showFigure3D] 找不到3D容器元素 #mainview3d');
          return;
        }

        // ========== 数据转换缓存机制 ==========
        // 检查数据是否变化（通过比较长度和第一个节点的ID）
        const nodesLength = this.nodes.length;
        const edgesLength = this.edges.length;
        const firstNodeId = this.nodes.length > 0 ? this.nodes[0].id : null;
        const lastNodeId = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].id : null;
        const firstEdgeSource = this.edges.length > 0 ? this.edges[0].source : null;
        
        // 检查是否需要重新转换数据
        const needReconvert = !this._cachedGDataBase || 
          this._cachedNodesLength !== nodesLength ||
          this._cachedEdgesLength !== edgesLength ||
          this._cachedFirstNodeId !== firstNodeId ||
          this._cachedLastNodeId !== lastNodeId ||
          this._cachedFirstEdgeSource !== firstEdgeSource;

        let gData;
        
        if (needReconvert) {
          console.log('🔄 [showFigure3D] 数据已变化，重新转换数据...', {
            cached: {
              nodesLength: this._cachedNodesLength,
              edgesLength: this._cachedEdgesLength
            },
            current: {
              nodesLength,
              edgesLength
            }
          });

          // 转换数据格式：将 this.nodes 和 this.edges 转换为 3d-force-graph 所需格式
          // 只缓存基础数据（不包含 neighbors 和 links 关系）
          const gDataBase = {
            nodes: this.nodes.map(node => ({
              id: node.id,
              name: node.name || node.id, // 保留 name (EXID) 用于标签显示，确保有值
              label: node.label || '', // 保留 label (Preferred name) 用于标签显示
              group: node.category,
              value: node.value // 保留value属性（用于nodeType3D == "2"时的节点大小计算）
            })),
            links: this.edges.map(edge => ({
              source: edge.source,
              target: edge.target
            }))
          };

          // 缓存基础数据
          this._cachedGDataBase = gDataBase;
          this._cachedNodesLength = nodesLength;
          this._cachedEdgesLength = edgesLength;
          this._cachedFirstNodeId = firstNodeId;
          this._cachedLastNodeId = lastNodeId;
          this._cachedFirstEdgeSource = firstEdgeSource;

          console.log('💾 [showFigure3D] 数据已缓存');
        } else {
          console.log('✅ [showFigure3D] 使用缓存数据，跳过转换');
        }

        // 从缓存中获取基础数据，深拷贝以避免修改缓存
        // 同时从this.nodes同步value属性（如果存在，特别是nodeType3D == "2"时）
        gData = {
          nodes: this._cachedGDataBase.nodes.map(node => {
            const nodeWithValue = { ...node };
            // 如果nodeType3D == "2"，需要从this.nodes同步value属性（因为可能刚计算完）
            if (this.nodeType3D == "2") {
              const sourceNode = this.nodes.find(n => n.id === node.id);
              if (sourceNode && sourceNode.value !== undefined) {
                nodeWithValue.value = sourceNode.value;
              }
            }
            return nodeWithValue;
          }),
          links: this._cachedGDataBase.links.map(link => ({ ...link }))
        };

        // 建立节点的邻居关系和链接关系（cross-link node objects）
        // 为每个节点添加 neighbors 和 links 数组，方便后续使用
        // 同时将 links 的 source 和 target 转换为节点对象引用（3d-force-graph 需要）
        // 性能优化：使用 Map 替代 find()，从 O(n*m) 降到 O(n+m)
        const nodeMap = new Map();
        gData.nodes.forEach(node => {
          nodeMap.set(node.id, node);
        });

        gData.links = gData.links.map(link => {
          // 通过 Map 快速查找节点对象（O(1) 时间复杂度）
          const a = nodeMap.get(link.source);
          const b = nodeMap.get(link.target);

          // 如果节点不存在，返回 null（后续会被过滤掉）
          if (!a || !b) {
            console.warn('⚠️ [showFigure3D] 跳过无效链接:', { source: link.source, target: link.target });
            return null;
          }

          // 将 source 和 target 转换为节点对象引用
          const linkWithObjects = {
            ...link,
            source: a,  // 使用节点对象引用
            target: b   // 使用节点对象引用
          };

          // 初始化 neighbors 数组（如果还没有）
          !a.neighbors && (a.neighbors = []);
          !b.neighbors && (b.neighbors = []);
          // 添加双向邻居关系
          a.neighbors.push(b);
          b.neighbors.push(a);

          // 初始化 links 数组（如果还没有）
          !a.links && (a.links = []);
          !b.links && (b.links = []);
          // 将链接添加到两个节点的 links 数组中
          a.links.push(linkWithObjects);
          b.links.push(linkWithObjects);

          return linkWithObjects;
        }).filter(link => link !== null); // 过滤掉无效的链接

        console.log('✅ [showFigure3D] 数据转换完成:', {
          nodesCount: gData.nodes.length,
          linksCount: gData.links.length,
          fromCache: !needReconvert,
          sampleNode: gData.nodes[0],
          sampleLink: gData.links[0],
          nodeNameType: this.nodeNameType,
          nodeNameTypeType: typeof this.nodeNameType,
          originalNodeSample: this.nodes[0], // 显示原始节点数据
          sampleNodeNeighbors: gData.nodes[0]?.neighbors?.length || 0, // 示例节点的邻居数量
          sampleNodeLinks: gData.nodes[0]?.links?.length || 0 // 示例节点的链接数量
        });

      // 如果 graph3D 实例已存在，先清理
      if (this.graph3D) {
        console.log('🧹 [showFigure3D] 清理现有3D图形实例...');
        try {
          // 清理防抖定时器
          if (this._updateHighlightTimer) {
            clearTimeout(this._updateHighlightTimer);
            this._updateHighlightTimer = null;
          }
          
          // 清理 WebGL 上下文
          if (this.graph3D.renderer && this.graph3D.renderer.getContext) {
            const gl = this.graph3D.renderer.getContext();
            if (gl) {
              const loseContext = gl.getExtension('WEBGL_lose_context');
              if (loseContext) {
                loseContext.loseContext();
              }
            }
          }
          this.graph3D._destructor();
        } catch (cleanupError) {
          console.warn('⚠️ [showFigure3D] 清理旧实例时出错:', cleanupError);
        }
        this.graph3D = null;
        // 等待一帧，确保清理完成
        await new Promise(resolve => setTimeout(resolve, 50));
      }

      // 创建节点标签显示函数，使用独立的3D节点名称类型
      const getNodeName = (node) => {
          // 使用独立的3D节点名称类型
          const nameType = String(this.nodeNameType3D);
          if (nameType === "1") {
            return node.name || node.id || '';
          } else {
            return node.label || node.name || node.id || '';
          }
      };

      const getNodeLabel = (node) => {
          // 使用独立的3D节点名称类型
          const nameType = String(this.nodeNameType3D);
          if (nameType === "1") {
            return node.name || node.id || '';
          } else {
            return node.label || node.name || node.id || '';
          }
      };

      // 保存 Vue 实例的引用，确保在回调中能访问
      const self = this;

      const highlightNodes = new Set();
      const highlightLinks = new Set();
      this._highlightNodes3D = highlightNodes;
      this._highlightLinks3D = highlightLinks;
      let hoverNode = null;

      // 初始化 3d-force-graph 实例
      try {
        // 根据nodeType3D设置节点大小
        // 如果nodeType3D == "2"，需要先计算节点大小
        if (this.nodeType3D == "2") {
          this.readSymbolSize3D();
        }
        
        // 根据nodeType3D设置节点大小
        let nodeSizeConfig;
        if (this.nodeType3D == "1") {
          // 固定大小模式：使用nodeRelSize
          const nodeRelSize = (this.nodevSize3D / 10) * 6;
          nodeSizeConfig = { nodeRelSize };
        } else {
          // 按边数比例模式：使用nodeVal
          nodeSizeConfig = {
            nodeVal: (node) => {
              // 优先从节点对象本身获取value（gData中的节点）
              let nodeValue = node.value;
              
              // 如果节点对象没有value，从this.nodes查找
              if (nodeValue === undefined) {
                const nodeData = this.nodes.find(n => n.id === node.id);
                if (nodeData && nodeData.value !== undefined) {
                  nodeValue = nodeData.value;
                }
              }
              
              if (nodeValue !== undefined) {
                // value已经是计算好的3D节点大小，直接返回
                // 确保最小值为4，保证节点可见
                return Math.max(nodeValue, 4);
              }
              
              console.warn('⚠️ [nodeVal] 未找到节点大小，使用默认值:', node.id);
              return 6; // 默认值
            }
          };
        }
        
        this.graph3D = ForceGraph3D()(container)
          .graphData(gData)
          .width(container.offsetWidth)
          .height(container.offsetHeight)
          .backgroundColor(this.backgroundColor3D) // 使用独立的3D背景颜色
          .nodeResolution(24) // 设置节点分辨率，使节点更平滑
          .nodeLabel(getNodeName) // 设置节点标签显示内容（用于悬停提示），根据 nodeNameType3D 显示 name 或 label
          .nodeColor(node => this.getNodeColor3D(node))
          .linkColor((link) => this.linecolor3D) // 使用独立的3D边颜色
          
        // 根据nodeType3D应用节点大小配置
        if (this.nodeType3D == "1") {
          this.graph3D.nodeRelSize(nodeSizeConfig.nodeRelSize);
        } else {
          this.graph3D.nodeVal(nodeSizeConfig.nodeVal);
        }
        
        this.graph3D
          .linkWidth(link => {
            const baseWidth = this.calculateY(this.edgeSize3D);
            return highlightLinks.has(link) ? baseWidth * 4 : baseWidth;
          })
          .linkOpacity(1 - this.lineTransparency3D / 100)
          .linkDirectionalParticles(link => highlightLinks.has(link) ? 4 : 0)
          .linkDirectionalParticleWidth(4)
          .onNodeHover(node => {
            if (self._cameraFocusInProgress) return;
            // no state change
            if ((!node && !highlightNodes.size) || (node && hoverNode === node)) return;

            highlightNodes.clear();
            highlightLinks.clear();
            if (node) {
              highlightNodes.add(node);
              node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
              node.links.forEach(link => highlightLinks.add(link));
            }

            hoverNode = node || null;

            updateHighlight();
          })
          .onLinkHover(link => {
            if (self._cameraFocusInProgress) return;
            highlightNodes.clear();
            highlightLinks.clear();

            if (link) {
              highlightLinks.add(link);
              highlightNodes.add(link.source);
              highlightNodes.add(link.target);
            }

            updateHighlight();
          })
          .nodeThreeObject(node => {
            // 创建文本精灵显示节点标签
            const sprite = new SpriteText(getNodeLabel(node));
            sprite.material.depthWrite = false; // 使文本背景透明
            sprite.color = this.labelColor3D;
            sprite.textHeight = this.frontSize3D; // 使用独立的3D标签大小
            sprite.center.y = 0; // 垂直居中
            sprite.center.x = 1.5; // 将文本向右偏移，显示在节点右侧（与2D图的position: 'right'一致）
            return sprite;
          })
          .nodeThreeObjectExtend(true) // 扩展节点对象，允许在默认节点基础上添加文本
          .nodeOpacity(1 - (this.nodeTransparency3D || 25) / 100) // 使用独立的3D节点透明度
          .cooldownTicks(100) // 减少冷却时间，更快停止模拟（默认300）
          .onNodeDragEnd(node => {
            node.fx = node.x;
            node.fy = node.y;
            node.fz = node.z;
        });

        // 设置物理引擎参数
        this.graph3D.d3Force('charge').strength(-180);
        this.graph3D.d3Force('link').distance(30); // 设置链接距离，帮助物理引擎更快稳定

        // 确保 highlightNodes 已初始化
        if (!self.highlightNodes) {
          self.highlightNodes = new Set();
        }

        // 清理之前的防抖定时器（如果存在）
        if (self._updateHighlightTimer) {
          clearTimeout(self._updateHighlightTimer);
          self._updateHighlightTimer = null;
        }
        
        // 原始的 updateHighlight 函数
        const updateHighlightImmediate = () => {
          const baseWidth = this.calculateY(this.edgeSize3D);
          this.graph3D
              .nodeColor(this.graph3D.nodeColor())
              .nodeOpacity(1 - this.nodeTransparency3D / 100)
              .linkWidth((link) => (highlightLinks.has(link) ? baseWidth * 4 : baseWidth))
              .linkOpacity(1 - this.lineTransparency3D / 100)
              .linkDirectionalParticles((link) => (highlightLinks.has(link) ? 4 : 0));
        };

        // 清空所有高亮（包括闭包内的 hoverNode）并立即刷新
        this._clearAllHighlights3D = () => {
          hoverNode = null;
          highlightNodes.clear();
          highlightLinks.clear();
          updateHighlightImmediate();
        };

        // 防抖版本的 updateHighlight 函数（16ms延迟，约60fps）
        const updateHighlight = () => {
          // 清除之前的定时器
          if (self._updateHighlightTimer) {
            clearTimeout(self._updateHighlightTimer);
          }
          
          // 设置新的定时器，延迟执行更新
          self._updateHighlightTimer = setTimeout(() => {
            updateHighlightImmediate();
            self._updateHighlightTimer = null;
          }, 16); // 16ms ≈ 60fps，保证流畅的交互体验
        };

        // 供表格联动调用：从外部更新高亮后刷新 3D 图
        this._update3DHighlight = updateHighlightImmediate;

      } catch (error) {
        console.error('💥 [showFigure3D] 3D图形渲染失败:', {
          error: error.message,
          stack: error.stack
        });
      }
      } finally {
        // 无论成功还是失败，都要重置渲染标志位
        this._isRendering3D = false;
        console.log('🔄 [showFigure3D] 渲染标志位已重置');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* 右侧栏：与左侧渲染视图等高 95vh，内部 flex 分配，避免整体溢出 */
.layout-panel-right {
  border: 1px #e4e7ed solid;
  height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.layout-panel-tabs-row {
  flex: 0 0 auto;
  height: 45vh;
  min-height: 0;
}
.layout-panel-divider-row {
  flex: 0 0 auto;
  height: 5vh;
  min-height: 0;
}
/* Layout Settings 区域：占满剩余高度并纵向滚动，最小宽度 620px 时左右滑动 */
.layout-settings-scroll-outer {
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 15px;
  overflow-x: auto;
  overflow-y: auto;
}
.layout-settings-scroll-inner {
  min-width: 620px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.demo-color-block {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.demo-color-block .demonstration {
  margin-right: 16px;
}

.nowrap-text {
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 超出文本长度时显示省略号 */
  width: 150px; /* 限制 span 元素的宽度 */
  text-align: left; /*字体左对齐*/
}

.centered-placeholder {
  /* text-align: center; */
  text-align: left; /* 输入框中的文本居中 */
}

.centered-placeholder ::v-deep .el-input__inner::placeholder {
  /* text-align: center;*/
  text-align: left; /* placeholder 内容居中显示 */
}

.radio-row {
  display: flex;
  align-items: flex-start;
}

/* Label type / Node name 等单行多选项：空间不足时换行，避免重叠 */
.radio-options-wrap {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin: 0;
}
.radio-options-wrap :deep(.el-radio) {
  margin-right: 0; /* 用 gap 控制间距，避免与固定 margin 叠加 */
}

/* 确保上下两个选择框的第一个选项对齐，给 EXID 设置最小宽度 */
.radio-options-wrap :deep(.radio-first-option) {
  min-width: 140px; /* 与 "Keep node size same" 的宽度对齐 */
  display: inline-flex;
  align-items: center;
}

.divider-text {
  border: 1px solid #E5E7ED; /* 边框样式和颜色 */
  padding: 6px 8px; /* 在文本周围添加一些填充 */
  border-radius: 4px; /* 边框圆角 */
}

.el-table th.is-center {
  text-align: center; /* 让表头文字居中 */
  vertical-align: top; /* 让表头文字居上 */
}

.demo-color-block {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.demo-color-block .demonstration {
  margin-right: 16px;
}

/* Full data 表格滚动条样式 - 使用专门的作用域类，确保只影响表格内部滚动条 */
/* 通过 .full-data-section 限定作用域，避免影响页面整体滚动条 */
.full-data-section ::v-deep(.full-data-table .el-table__body-wrapper)::-webkit-scrollbar {
  width: 16px !important;
  height: 16px !important;
}

.full-data-section ::v-deep(.full-data-table .el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background-color: #409EFF !important;
  border-radius: 8px !important;
}

.full-data-section ::v-deep(.full-data-table .el-table__body-wrapper)::-webkit-scrollbar-thumb:hover {
  background-color: #66b1ff !important;
}

.full-data-section ::v-deep(.full-data-table .el-table__body-wrapper)::-webkit-scrollbar-track {
  background-color: #f0f0f0 !important;
}

/* 同时处理 Element Plus 的 el-scrollbar 组件（如果使用） */
.full-data-section ::v-deep(.full-data-table .el-scrollbar__bar.is-vertical) {
  width: 16px !important;
}

.full-data-section ::v-deep(.full-data-table .el-scrollbar__bar.is-horizontal) {
  height: 16px !important;
}

.full-data-section ::v-deep(.full-data-table .el-scrollbar__thumb) {
  background-color: #409EFF !important;
  border-radius: 8px !important;
}

.full-data-section ::v-deep(.full-data-table .el-scrollbar__thumb:hover) {
  background-color: #66b1ff !important;
}

/* 恢复外部页面滚动条的默认样式 - 确保不受表格样式影响 */
/* 注意：不要在这里设置全局滚动条样式，让浏览器使用默认样式 */
/* 只在 .full-data-section 内设置自定义样式即可 */

/* 3D图图例样式 - 模拟ECharts图例 */
.legend-3d-container {
  position: absolute;
  top: 25px;
  left: 6px;
  padding: 6px;
  z-index: 100;
  pointer-events: none; /* 不阻挡3D图的交互 */
}

.legend-3d-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  color: #ffffff;
  pointer-events: auto; /* 允许图例项交互（如果需要） */
}

.legend-3d-item:last-child {
  margin-bottom: 0;
}

.legend-3d-icon {
  display: inline-block;
  margin-right: 10px;
  flex-shrink: 0;
}

.legend-3d-icon.legend-icon-circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.legend-3d-icon.legend-icon-triangle {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 10px solid;
  background-color: transparent !important;
  border-radius: 0;
  margin-top: 2px; /* 稍微调整位置使其与文字对齐 */
}

.legend-3d-icon.legend-icon-diamond {
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  margin-top: 2px; /* 稍微调整位置使其与文字对齐 */
}

.legend-3d-text {
  color: #ffffff;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.2;
}

/* 3D图右侧边界线 */
.right-border-3d {
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #e4e7ed;
  z-index: 50;
  pointer-events: none;
}
</style>
